import { useState, useEffect, useRef } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import Colorize from "../components/colorize";
import TranslaterD from "../components/language";
import navbar from "../assets/css/navbar.module.css";
import user_logo from "../assets/img/avatar.jpg";
import { styled } from "@mui/material/styles";
import Badge from "@mui/material/Badge";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import axios from "axios";
import { makeStyles } from "@mui/styles";
import { Autocomplete, TextField } from "@mui/material";


import { rootPath } from "../utils/main"

const mountedStyle = { animation: "inAnimation 250ms ease-in" };
const unmountedStyle = {
  animation: "outAnimation 270ms ease-out",
  animationFillMode: "forwards",
};
const useStyles = makeStyles({
  paper: {
    backgroundColor: "var(--theme-bg)",
  },
});

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "var(--theme)",
    color: "#fff",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

function Root() {
  const help_text = useRef(null);
  const aside = useRef(null);
  const [isSidebar, setSidebar] = useState(false);
  const [isColorD, setColorD] = useState(false);
  const [isTranslaterD, setTranslaterD] = useState(false);
  const [isNotification, setNotfication] = useState(false);
  const [avatar, setAvatar] = useState(user_logo);
  const [companies, setcompanies] = useState([]);
  const [work_on, setWorkOn] = useState(null);
  const [status, setStatus] = useState("");
  
  const [colors, setColors] = useState([
    { id: "0", slug: "purple", color: "#6285FF" },
    { id: "1", slug: "green", color: "#4FB286" },
    { id: "2", slug: "red", color: "#FC3F1D" },
    { id: "3", slug: "yellow", color: "#E8B54F" },
    { id: "5", slug: "dark_red", color: "#84363D" },
    { id: "6", slug: "dark_blue", color: "#053C5E" },
  ]);

  const [who, setWho] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    let slug = localStorage.getItem("theme");
    if (slug) {
      colors.map(
        (color) => color.slug === slug && ChangeColor(color)
      );
    } else {
      ChangeColor(colors[0]);
    }
  }, [colors])
  
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      axios
        .post("accounts/api/token/verify/", { token })
        .then((response) => {
          axios.defaults.headers.common["Authorization"] = "Bearer " + token;

          setTimeout(() => {
            axios
              .get("accounts/users/me/", )
              .then((res) => {
                localStorage.setItem("api", res.data?.work_on?.slug);
                let a = rootPath + res.data.avatar_select_display;
                let obj = res.data;

                setAvatar(a);
                setcompanies(res.data.work_for);
                setWorkOn(res.data.work_on);
                setWho(obj["who"]);

                localStorage.setItem("who", JSON.stringify(obj["who"]))
                localStorage.setItem("user", JSON.stringify(obj));


                delete obj["work_for"];
                delete obj["percent"];
                delete obj["absolute_salary"];
                let who = ["A", "M", "C", "T", "R", "S"];
                setStatus(who[parseInt(res.data.who)]);
              })
              .catch((err) => console.log(err));
  
          axios
            .get("accounts/colors/")
            .then((response) => {
              setColors(response.data);

              window.scrollTo(0, 0);
              let slug = localStorage.getItem("theme");
              if (slug) {
                response.data.map(
                  (color) => color.slug === slug && ChangeColor(color)
                );
              } else {
                ChangeColor(colors[0]);
              }
            })
            .catch((err) => console.log(err));
          }, 50);


        })
        .catch((error) => {
          console.error("Error validating token:", error);
          navigate("/login");
        });
          
    } else {
      navigate("/login");
    }
  }, [useLocation()]);



  function ChangeCompnay(newValue) {
    if (newValue !== null) {
      axios
        .post(`accounts/users/me/`, {
          work_on: newValue.id,
        })
        .then((res) => {
          setWorkOn(newValue);
          window.location.reload(false);
        })
        .catch((error) => console.log(error));
    }
  }
  const classes = useStyles();

  const body = document.documentElement;
  const lightTheme = "light";
  const darkTheme = "dark";
  let theme;
  const [browseTheme, setBrowseTheme] = useState(
    localStorage.getItem("theme-bg") === "light" ? true : false
  );
  const [colorTheme, setcolorTheme] = useState(localStorage.getItem("theme"));

  if (localStorage) {
    theme = localStorage.getItem("theme-bg");
  }

  if (theme === lightTheme || theme === darkTheme) {
    body.className = theme;
  } else {
    body.className = lightTheme;
  }

  const switchTheme = (e) => {
    if (theme === darkTheme) {
      body.className = lightTheme;
      localStorage.setItem("theme-bg", "light");
      theme = lightTheme;
      setBrowseTheme(true);
    } else {
      body.className = darkTheme;
      localStorage.setItem("theme-bg", "dark");
      theme = darkTheme;
      setBrowseTheme(false);
    }
  };

  useEffect(() => {
    help_text.current.addEventListener("touchstart", handleTouchStart, false);
    help_text.current.addEventListener("touchmove", handleTouchMove, false);
    aside.current.addEventListener("touchstart", handleTouchStart, false);
    aside.current.addEventListener("touchmove", handleTouchMove, false);

    var xDown = null;
    var yDown = null;

    function getTouches(evt) {
      return (
        evt.touches || // browser API
        evt.originalEvent.touches
      ); // jQuery
    }

    function handleTouchStart(evt) {
      const firstTouch = getTouches(evt)[0];
      xDown = firstTouch.clientX;
      yDown = firstTouch.clientY;
    }

    function handleTouchMove(evt) {
      if (!xDown || !yDown) {
        return;
      }

      var xUp = evt.touches[0].clientX;
      var yUp = evt.touches[0].clientY;

      var xDiff = xDown - xUp;
      var yDiff = yDown - yUp;

      if (Math.abs(xDiff) > Math.abs(yDiff)) {
        /*most significant*/
        if (xDiff > 0) {
          setSidebar(false);
          window.onscroll = () => setSidebar(false);
          setColorD(false);
        } else {
          setSidebar(true);
        }
      } else {
        if (yDiff > 0) {
          /* down swipe */
        } else {
          /* up swipe */
        }
      }
      /* reset values */
      xDown = null;
      yDown = null;
    }
    // console.clear()
  });



  useEffect(
    () =>
      function () {
        setSidebar(false);
        setNotfication(false);
      },
    [useLocation()]
  );

  // const language = [
  //   { id: "0", image: UZB_flag, slug: "Uz", title: "Uzbkecha" },
  //   { id: "1", image: ENG_flag, slug: "En", title: "Inglizcha" },
  //   { id: "2", image: RU_flag, slug: "Ru", title: "Ruscha" },
  // ];

  function ChangeColor(color) {
    document.documentElement.style.setProperty("--theme", color.color);
    localStorage.setItem("theme", color.slug);
    setcolorTheme(color.slug);
  }
  function allClose() {
    setSidebar(false);
    setColorD(false);
    setTranslaterD(false);
    setNotfication(false);
  }
  return (
    <>
      <nav className={`${navbar.nav} ${isSidebar ? navbar.active : ""}`}>
        <div className={navbar.logo} onClick={() => setSidebar(true)}>
          <svg
            className={navbar.logo}
            width="30"
            height="25"
            viewBox="0 0 30 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_189_79"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="30"
              height="25"
            >
              <path d="M30 0H0V24.9622H30V0Z" fill="white" />
            </mask>
            <g>
              <path
                d="M6.765 4.3463V18.5195C6.75574 19.4105 6.39527 20.2619 5.76194 20.8886C5.12861 21.5154 4.27354 21.867 3.3825 21.867C2.49145 21.867 1.63639 21.5154 1.00305 20.8886C0.369717 20.2619 0.00926656 19.4105 0 18.5195V4.3463C0.000582015 3.4493 0.357428 2.58924 0.992056 1.9553C1.62669 1.32135 2.48713 0.965437 3.38415 0.965824C3.94511 0.964335 4.4974 1.10399 4.99024 1.37193C4.99793 1.37522 5.00122 1.37924 5.00488 1.37924C5.00678 1.38133 5.00938 1.38263 5.0122 1.3829C5.2927 1.53594 5.54912 1.72949 5.77317 1.95729C6.08766 2.27059 6.33713 2.6429 6.50737 3.05288C6.67756 3.46286 6.76511 3.90241 6.765 4.3463Z"
                fill="#6285FF"
              />
              <path
                d="M14.4951 7.40854V21.578C14.4951 22.0222 14.4076 22.4621 14.2376 22.8724C14.0676 23.2828 13.8185 23.6556 13.5044 23.9697C13.1904 24.2838 12.8175 24.5329 12.4071 24.7029C11.9968 24.8729 11.557 24.9604 11.1128 24.9604C10.6686 24.9604 10.2288 24.8729 9.81843 24.7029C9.40805 24.5329 9.03521 24.2838 8.72113 23.9697C8.40704 23.6556 8.1579 23.2828 7.98792 22.8724C7.81794 22.4621 7.73047 22.0222 7.73047 21.578V7.40854C7.73036 6.9641 7.81783 6.52398 7.98788 6.11338C8.1579 5.70274 8.40719 5.32965 8.72146 5.01538C9.03572 4.70111 9.40882 4.45182 9.81942 4.28181C10.2301 4.11176 10.6702 4.02428 11.1146 4.02439C11.2353 4.02439 11.3524 4.03171 11.4658 4.04232H11.4735C12.3033 4.13254 13.0707 4.52598 13.6283 5.14712C14.1859 5.76827 14.4946 6.57381 14.4951 7.40854Z"
                fill="#6285FF"
              />
              <path
                d="M22.2695 3.38045V17.5536C22.2695 18.4507 21.9132 19.311 21.2789 19.9453C20.6445 20.5796 19.7842 20.9359 18.8872 20.9359C17.9902 20.9359 17.1299 20.5796 16.4955 19.9453C15.8612 19.311 15.5049 18.4507 15.5049 17.5536V3.38045C15.5049 2.93621 15.5924 2.49632 15.7626 2.08594C15.9327 1.67557 16.182 1.30274 16.4963 0.988785C16.8106 0.674831 17.1837 0.425904 17.5942 0.256233C18.0048 0.0865625 18.4448 -0.000521894 18.889 -4.11141e-05C19.0286 -0.00147909 19.1681 0.00830851 19.3061 0.0292271H19.3134C20.0573 0.11923 20.7493 0.456848 21.2781 0.987764C21.5925 1.30178 21.842 1.67475 22.0121 2.08533C22.1823 2.49591 22.2697 2.93602 22.2695 3.38045Z"
                fill="#6285FF"
              />
              <path
                d="M29.9999 7.24716V21.417C29.9999 21.8612 29.9124 22.301 29.7424 22.7114C29.5724 23.1218 29.3233 23.4946 29.0092 23.8087C28.6951 24.1228 28.3222 24.3719 27.9119 24.5419C27.5015 24.7119 27.0617 24.7994 26.6175 24.7994C26.1734 24.7994 25.7335 24.7119 25.3232 24.5419C24.9128 24.3719 24.5399 24.1228 24.2259 23.8087C23.9118 23.4946 23.6627 23.1218 23.4927 22.7114C23.3227 22.301 23.2352 21.8612 23.2352 21.417V7.24716C23.2352 6.80272 23.3227 6.36267 23.4927 5.95204C23.6628 5.54144 23.9121 5.16834 24.2263 4.85411C24.5406 4.53984 24.9137 4.29058 25.3243 4.12054C25.7349 3.95049 26.1749 3.86297 26.6194 3.86301C27.067 3.86118 27.5102 3.95096 27.9218 4.12679H27.9255C27.9274 4.12888 27.93 4.13019 27.9328 4.13045C28.3355 4.29874 28.701 4.54493 29.0084 4.85484C29.3238 5.16808 29.5739 5.54089 29.7441 5.95156C29.9143 6.36223 30.0012 6.80261 29.9999 7.24716Z"
                fill="url(#paint0_linear_189_79)"
              />
              <g opacity="0.3">
                <path
                  d="M6.765 8.42554V18.5194C6.75574 19.4104 6.39527 20.2618 5.76194 20.8886C5.12861 21.5154 4.27354 21.8669 3.3825 21.8669C2.49145 21.8669 1.63639 21.5154 1.00305 20.8886C0.369717 20.2618 0.00926656 19.4104 0 18.5194V17.9377C0 17.9377 0.00731759 18.0215 0.0219517 18.1752C0.0292688 18.3325 0.0512199 18.5633 0.0881711 18.8447C0.1505 19.18 0.258712 19.5051 0.409756 19.8109C0.676815 20.3541 1.09264 20.8102 1.60885 21.1263C2.12505 21.4424 2.7204 21.6053 3.32561 21.5963C3.60008 21.5934 3.87304 21.5553 4.1378 21.4829C4.69712 21.3254 5.20141 21.015 5.5939 20.5865C5.99583 20.1506 6.26049 19.606 6.35488 19.0207C6.3622 18.9475 6.38049 18.889 6.38415 18.8048L6.39915 18.556C6.4061 18.428 6.40244 18.2341 6.4061 18.0768C6.4061 17.7475 6.40976 17.4146 6.41341 17.089C6.41341 16.4341 6.43537 15.7902 6.44305 15.1646C6.46829 13.917 6.50854 12.7532 6.5561 11.7548C6.64427 9.75724 6.765 8.42554 6.765 8.42554Z"
                  fill="#6285FF"
                />
              </g>
              <g opacity="0.6">
                <path
                  d="M5.00524 1.37927C4.87804 1.3378 4.74856 1.3036 4.61744 1.27683C4.27943 1.19848 3.93234 1.16648 3.58573 1.18171C3.47673 1.18577 3.36809 1.19677 3.26049 1.21463C3.14714 1.22856 3.03474 1.24933 2.9239 1.27683C2.16918 1.44753 1.49608 1.8725 1.01744 2.48049C0.850584 2.68494 0.710437 2.90979 0.600366 3.14963C0.495282 3.38184 0.415555 3.62471 0.362561 3.87402C0.335648 4.00086 0.31598 4.1291 0.303658 4.25817L0.292683 4.35695C0.292683 4.36061 0.289024 4.41549 0.285365 4.4411C0.281707 4.50695 0.278049 4.5728 0.271098 4.635C0.256098 4.8911 0.230488 5.13256 0.208537 5.35573C0.16396 5.85402 0.0943602 6.34979 0 6.8411V4.34597C0.000675505 3.75914 0.153928 3.18261 0.444713 2.67291C0.735498 2.16321 1.15382 1.73789 1.65862 1.43868C2.16342 1.13948 2.73735 0.976674 3.32407 0.966258C3.91079 0.955842 4.49012 1.09817 5.00524 1.37927Z"
                  fill="#6285FF"
                />
              </g>
              <g opacity="0.3">
                <path
                  d="M14.4951 11.4728V21.578C14.4951 22.0222 14.4076 22.462 14.2376 22.8724C14.0676 23.2827 13.8185 23.6556 13.5044 23.9697C13.1904 24.2838 12.8175 24.5329 12.4071 24.7029C11.9968 24.8729 11.557 24.9603 11.1128 24.9603C10.6686 24.9603 10.2288 24.8729 9.81843 24.7029C9.40805 24.5329 9.03521 24.2838 8.72113 23.9697C8.40704 23.6556 8.1579 23.2827 7.98792 22.8724C7.81794 22.462 7.73047 22.0222 7.73047 21.578V21.1683C7.73047 21.1683 7.73779 21.2524 7.75242 21.4057C7.76537 21.6273 7.79596 21.8475 7.84388 22.0642C8.0091 22.8176 8.42907 23.4909 9.03291 23.9707C9.42419 24.2788 9.88107 24.4928 10.3683 24.5963C10.4928 24.6215 10.6186 24.6398 10.7451 24.6512C10.8839 24.6607 11.0231 24.6632 11.1622 24.6585C11.4378 24.6434 11.7106 24.5954 11.9747 24.5155C12.5219 24.336 13.01 24.0109 13.3866 23.5752C13.7728 23.1321 14.0197 22.5848 14.0963 22.002C14.1179 21.8517 14.1301 21.7002 14.1329 21.5484L14.1366 21.0541C14.1366 20.7248 14.1402 20.3956 14.1442 20.0703C14.1442 19.4228 14.1658 18.7825 14.1735 18.1606C14.1988 16.9236 14.239 15.7679 14.2866 14.7764C14.3744 12.7939 14.4951 11.4728 14.4951 11.4728Z"
                  fill="#6285FF"
                />
              </g>
              <g opacity="0.6">
                <path
                  d="M11.4658 4.04232C11.4329 4.05 11.3049 4.06829 11.1036 4.09756C10.9902 4.12683 10.8516 4.14878 10.7012 4.19268C10.5333 4.24167 10.3685 4.30017 10.2073 4.36793C10.0224 4.4497 9.84382 4.54522 9.67315 4.65366C9.48883 4.77575 9.31396 4.91148 9.14998 5.05976C8.98257 5.22209 8.83066 5.39967 8.69632 5.59024C8.55807 5.78356 8.44033 5.99078 8.3451 6.20854C8.25232 6.42659 8.18135 6.65331 8.13327 6.88537C8.10872 7.00138 8.09029 7.11864 8.07803 7.23659L8.05974 7.41183L8.05242 7.60244C8.02681 8.10366 7.98657 8.57159 7.93901 8.97439C7.89444 9.42549 7.82482 9.87373 7.73047 10.3171V7.40854C7.73036 6.9641 7.81783 6.52398 7.98788 6.11338C8.1579 5.70274 8.40719 5.32965 8.72146 5.01538C9.03572 4.70111 9.40882 4.45182 9.81942 4.28181C10.2301 4.11176 10.6702 4.02428 11.1146 4.02439C11.2353 4.02439 11.3524 4.03171 11.4658 4.04232Z"
                  fill="#6285FF"
                />
              </g>
              <g opacity="0.3">
                <path
                  d="M22.2695 4.82927V17.5536C22.2695 18.4507 21.9132 19.311 21.2789 19.9453C20.6445 20.5796 19.7842 20.936 18.8872 20.936C17.9902 20.936 17.1299 20.5796 16.4955 19.9453C15.8612 19.311 15.5049 18.4507 15.5049 17.5536V17.2683C15.5049 17.2683 15.5122 17.3598 15.5268 17.5317C15.5467 17.7779 15.5895 18.0216 15.6549 18.2598C15.7601 18.6226 15.9259 18.9651 16.1451 19.2728C16.4202 19.6657 16.7788 19.9931 17.1951 20.2313C17.6784 20.5119 18.2277 20.6585 18.7866 20.6561C19.0828 20.6594 19.3778 20.6175 19.6613 20.5317C19.9597 20.4489 20.2436 20.3205 20.5028 20.1512C21.0422 19.797 21.4588 19.2845 21.6955 18.6841L21.7796 18.4573L21.8382 18.2191C21.8601 18.139 21.8638 18.0622 21.8784 17.9854C21.8941 17.9021 21.9015 17.8176 21.9004 17.7329C21.9187 17.4036 21.9004 17.0049 21.904 16.6463C21.9077 15.9073 21.9113 15.1683 21.9187 14.4402C21.9187 13.7122 21.9406 12.9988 21.9479 12.3073C21.9735 10.9207 22.0138 9.62923 22.0613 8.5207C22.1488 6.30362 22.2695 4.82927 22.2695 4.82927Z"
                  fill="#6285FF"
                />
              </g>
              <g opacity="0.6">
                <path
                  d="M19.3061 0.0292271C19.2585 0.0365442 19.1378 0.0548368 18.9585 0.076788C18.8488 0.0841051 18.7061 0.1313 18.5524 0.15691C18.3839 0.203439 18.2178 0.25851 18.0549 0.32191C17.8679 0.399855 17.6869 0.491571 17.5134 0.596301C17.3242 0.712002 17.1456 0.844225 16.9796 0.991422C16.8915 1.06459 16.8146 1.1524 16.7345 1.23289C16.6613 1.32801 16.5768 1.41179 16.511 1.51093C16.368 1.70173 16.2465 1.90774 16.1488 2.1252C16.0478 2.34071 15.9705 2.56654 15.9183 2.79874C15.9037 2.91581 15.8671 3.00362 15.8561 3.14264L15.8378 3.33252L15.8342 3.38045V3.38411L15.8305 3.3874V3.41337L15.8268 3.5085C15.8012 4.01338 15.761 4.48167 15.7134 4.88411C15.669 5.33641 15.5993 5.7859 15.5049 6.23045V3.38045C15.5049 2.93621 15.5924 2.49632 15.7626 2.08594C15.9327 1.67557 16.182 1.30274 16.4963 0.988785C16.8106 0.674831 17.1837 0.425904 17.5942 0.256233C18.0048 0.0865625 18.4448 -0.000521894 18.889 -4.11141e-05C19.0286 -0.00147909 19.1681 0.00830851 19.3061 0.0292271Z"
                  fill="#6285FF"
                />
              </g>
              <g opacity="0.6">
                <path
                  d="M27.9218 4.12679C27.8889 4.11911 27.7572 4.0935 27.5486 4.06825C27.4279 4.05362 27.2816 4.04594 27.1169 4.04228C26.9335 4.04158 26.7502 4.05271 26.5682 4.07557C26.3581 4.10685 26.1503 4.15196 25.9462 4.21057C25.7263 4.28151 25.5132 4.37224 25.3096 4.48167C24.8746 4.71973 24.4964 5.04926 24.2011 5.44752C24.05 5.64688 23.9223 5.86291 23.8206 6.09143C23.7226 6.31236 23.6478 6.54285 23.5974 6.77923C23.5701 6.89843 23.5517 7.01949 23.5425 7.14143L23.5316 7.23289L23.5279 7.25118L23.5243 7.26545L23.5206 7.31338C23.5169 7.37557 23.5133 7.43411 23.5096 7.4963C23.4913 7.73777 23.4694 7.96825 23.4438 8.17679C23.3994 8.64969 23.3297 9.11985 23.2352 9.58533V7.24716C23.2352 6.80272 23.3227 6.36267 23.4927 5.95204C23.6628 5.54144 23.9121 5.16834 24.2263 4.85411C24.5406 4.53984 24.9137 4.29058 25.3243 4.12054C25.7349 3.95049 26.1749 3.86297 26.6194 3.86301C27.067 3.86118 27.5102 3.95096 27.9218 4.12679Z"
                  fill="#6285FF"
                />
              </g>
              <g opacity="0.3">
                <path
                  d="M29.9999 12.3293V21.4171C29.9999 21.8612 29.9124 22.3011 29.7424 22.7114C29.5724 23.1218 29.3233 23.4946 29.0092 23.8087C28.6951 24.1228 28.3222 24.3719 27.9119 24.5419C27.5015 24.7119 27.0617 24.7994 26.6175 24.7994C26.1734 24.7994 25.7335 24.7119 25.3232 24.5419C24.9128 24.3719 24.5399 24.1228 24.2259 23.8087C23.9118 23.4946 23.6627 23.1218 23.4927 22.7114C23.3227 22.3011 23.2352 21.8612 23.2352 21.4171C23.2352 21.4171 23.2462 21.4939 23.2682 21.6402C23.2774 21.727 23.2945 21.8127 23.3194 21.8963C23.342 22.0121 23.3738 22.1258 23.4145 22.2366C23.6001 22.7979 23.9323 23.2994 24.3768 23.6892C24.8212 24.079 25.3618 24.3429 25.9425 24.4537C26.0633 24.4756 26.1767 24.4829 26.2974 24.4976L26.5023 24.5012H26.6377L26.6852 24.4939C26.9432 24.4805 27.1987 24.4362 27.4462 24.3622C27.9579 24.2037 28.4203 23.9164 28.7889 23.5277C28.9768 23.328 29.139 23.1057 29.2718 22.8659C29.3979 22.6227 29.4926 22.3646 29.5535 22.0976C29.5862 21.9677 29.6094 21.8356 29.623 21.7024L29.6377 21.4756V21.4171L29.6413 21.3765V21.2634C29.6413 20.9561 29.645 20.6484 29.6486 20.3451C29.6486 19.7415 29.6706 19.1415 29.6779 18.5671C29.7035 17.411 29.7438 16.3317 29.7913 15.4098C29.8791 13.5582 29.9999 12.3293 29.9999 12.3293Z"
                  fill="#6285FF"
                />
              </g>
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_189_79"
                x1="26.6175"
                y1="4.34451"
                x2="26.6175"
                y2="25.5531"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#6285FF" />
                <stop offset="1" stopColor="#6285FF" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          onChange={(event, newValue) => ChangeCompnay(newValue)}
          options={companies}
          classes={{ paper: classes.paper }}
          getOptionLabel={(option) => option.title || ""}
          value={work_on}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          style={{ width: "200px" }}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              placeholder="filialni almashtirish"
            />
          )}
        />
        <div className={navbar.end_content}>
          <div
            className={`${navbar.theme_control} ${
              browseTheme ? navbar.active : ""
            }`}
            onClick={switchTheme}
          >
            <div className={navbar.toggle}>
              {browseTheme ? (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.556 9.88071L17.1281 9.62212V9.62212L17.556 9.88071ZM10.1193 2.44397L9.8607 2.01603V2.01603L10.1193 2.44397ZM17.8333 10C17.8333 14.3262 14.3262 17.8333 9.99999 17.8333V18.8333C14.8785 18.8333 18.8333 14.8785 18.8333 10H17.8333ZM9.99999 17.8333C5.67376 17.8333 2.16666 14.3262 2.16666 10H1.16666C1.16666 14.8785 5.12147 18.8333 9.99999 18.8333V17.8333ZM2.16666 10C2.16666 5.67377 5.67376 2.16667 9.99999 2.16667V1.16667C5.12147 1.16667 1.16666 5.12149 1.16666 10H2.16666ZM12.9167 12C10.2013 12 7.99999 9.79874 7.99999 7.08334H6.99999C6.99999 10.351 9.64897 13 12.9167 13V12ZM17.1281 9.62212C16.2663 11.0483 14.7024 12 12.9167 12V13C15.0669 13 16.9486 11.8527 17.984 10.1393L17.1281 9.62212ZM7.99999 7.08334C7.99999 5.29763 8.95166 3.73372 10.3779 2.87191L9.8607 2.01603C8.14728 3.05138 6.99999 4.93314 6.99999 7.08334H7.99999ZM9.99999 2.16667C9.98457 2.16667 9.96068 2.16352 9.93336 2.15188C9.90622 2.14031 9.8838 2.12382 9.86713 2.10648C9.8356 2.07366 9.83248 2.04747 9.83248 2.04746C9.83232 2.04625 9.83205 2.04727 9.83285 2.04537C9.83471 2.04092 9.84263 2.02695 9.8607 2.01603L10.3779 2.87191C10.7463 2.64929 10.8675 2.23931 10.8235 1.91362C10.7779 1.5764 10.5163 1.16667 9.99999 1.16667V2.16667ZM17.984 10.1393C17.973 10.1574 17.9591 10.1653 17.9546 10.1671C17.9527 10.1679 17.9537 10.1677 17.9525 10.1675C17.9525 10.1675 17.9263 10.1644 17.8935 10.1329C17.8762 10.1162 17.8597 10.0938 17.8481 10.0666C17.8365 10.0393 17.8333 10.0154 17.8333 10H18.8333C18.8333 9.48369 18.4236 9.22205 18.0864 9.17651C17.7607 9.13253 17.3507 9.25371 17.1281 9.62212L17.984 10.1393Z"
                    fill="#090909"
                  />
                </svg>
              ) : (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="10" cy="9.99999" r="4.16667" stroke="white" />
                  <path
                    d="M10 1.66667V3.33334"
                    stroke="white"
                    strokeLinecap="round"
                  />
                  <path
                    d="M10 16.6667V18.3333"
                    stroke="white"
                    strokeLinecap="round"
                  />
                  <path
                    d="M3.33334 10L1.66668 10"
                    stroke="white"
                    strokeLinecap="round"
                  />
                  <path
                    d="M18.3333 10L16.6667 10"
                    stroke="white"
                    strokeLinecap="round"
                  />
                  <path
                    d="M16.4815 3.51848L14.6299 5.21147"
                    stroke="white"
                    strokeLinecap="round"
                  />
                  <path
                    d="M3.51846 3.51848L5.37014 5.21147"
                    stroke="white"
                    strokeLinecap="round"
                  />
                  <path
                    d="M5.37027 14.6297L3.51842 16.4816"
                    stroke="white"
                    strokeLinecap="round"
                  />
                  <path
                    d="M16.4815 16.4815L14.6299 14.6296"
                    stroke="white"
                    strokeLinecap="round"
                  />
                </svg>
              )}
            </div>
          </div>

          <svg
            onClick={() => setColorD((current) => !current)}
            width="34"
            height="34"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15 3.4375C8.61651 3.4375 3.4375 8.62651 3.4375 15.0326C3.4375 20.9856 7.91076 25.889 13.6657 26.5515C14.2438 26.618 14.8625 26.3755 15.3572 25.8795C15.8091 25.4265 15.8091 24.691 15.3572 24.238C14.9673 23.847 14.5763 23.3261 14.3624 22.734C14.1433 22.1275 14.0891 21.3666 14.5337 20.6595C14.9374 20.0175 15.5426 19.6738 16.1776 19.5067C16.7891 19.3458 17.4667 19.3367 18.1175 19.3762C18.7225 19.4129 19.3738 19.4973 20.0056 19.5792C20.0589 19.5861 20.112 19.593 20.165 19.5998C20.8611 19.6897 21.5409 19.7734 22.1976 19.8049C23.5405 19.8693 24.5749 19.7 25.2818 19.1221C25.9583 18.569 26.5625 17.446 26.5625 15.0326C26.5625 8.62651 21.3835 3.4375 15 3.4375ZM1.5625 15.0326C1.5625 7.59559 7.57637 1.5625 15 1.5625C22.4236 1.5625 28.4375 7.59559 28.4375 15.0326C28.4375 17.7142 27.7664 19.5126 26.4685 20.5737C25.201 21.6099 23.5618 21.7475 22.1078 21.6778C21.3661 21.6422 20.6167 21.5487 19.9249 21.4594C19.8763 21.4531 19.8281 21.4468 19.7802 21.4406C19.1307 21.3566 18.5419 21.2804 18.004 21.2477C17.4213 21.2124 16.9785 21.2348 16.6548 21.3199C16.3547 21.3989 16.21 21.5159 16.121 21.6575C16.0725 21.7346 16.0383 21.8547 16.1259 22.0969C16.2186 22.3537 16.421 22.6493 16.6848 22.9139C17.8666 24.0987 17.8666 26.0188 16.6848 27.2036C15.872 28.0186 14.7102 28.5591 13.4513 28.4142C6.75706 27.6435 1.5625 21.9453 1.5625 15.0326ZM11.9813 7.81221C11.4635 7.81221 11.0438 8.23195 11.0438 8.74971C11.0438 9.26748 11.4635 9.68721 11.9813 9.68721C12.499 9.68721 12.9188 9.26748 12.9188 8.74971C12.9188 8.23195 12.499 7.81221 11.9813 7.81221ZM9.16875 8.74971C9.16875 7.19641 10.428 5.93721 11.9813 5.93721C13.5346 5.93721 14.7938 7.19641 14.7938 8.74971C14.7938 10.303 13.5346 11.5622 11.9813 11.5622C10.428 11.5622 9.16875 10.303 9.16875 8.74971ZM18.125 7.8125C17.6072 7.8125 17.1875 8.23223 17.1875 8.75C17.1875 9.26777 17.6072 9.6875 18.125 9.6875C18.6428 9.6875 19.0625 9.26777 19.0625 8.75C19.0625 8.23223 18.6428 7.8125 18.125 7.8125ZM15.3125 8.75C15.3125 7.1967 16.5717 5.9375 18.125 5.9375C19.6783 5.9375 20.9375 7.1967 20.9375 8.75C20.9375 10.3033 19.6783 11.5625 18.125 11.5625C16.5717 11.5625 15.3125 10.3033 15.3125 8.75ZM8.125 13.4375C7.60723 13.4375 7.1875 13.8572 7.1875 14.375C7.1875 14.8928 7.60723 15.3125 8.125 15.3125C8.64277 15.3125 9.0625 14.8928 9.0625 14.375C9.0625 13.8572 8.64277 13.4375 8.125 13.4375ZM5.3125 14.375C5.3125 12.8217 6.5717 11.5625 8.125 11.5625C9.6783 11.5625 10.9375 12.8217 10.9375 14.375C10.9375 15.9283 9.6783 17.1875 8.125 17.1875C6.5717 17.1875 5.3125 15.9283 5.3125 14.375ZM21.875 13.4375C21.3572 13.4375 20.9375 13.8572 20.9375 14.375C20.9375 14.8928 21.3572 15.3125 21.875 15.3125C22.3928 15.3125 22.8125 14.8928 22.8125 14.375C22.8125 13.8572 22.3928 13.4375 21.875 13.4375ZM19.0625 14.375C19.0625 12.8217 20.3217 11.5625 21.875 11.5625C23.4283 11.5625 24.6875 12.8217 24.6875 14.375C24.6875 15.9283 23.4283 17.1875 21.875 17.1875C20.3217 17.1875 19.0625 15.9283 19.0625 14.375Z"
              fill="#111111"
            />
          </svg>
          <NavLink to="/messages">
            <svg
              width="38"
              height="38"
              viewBox="0 -3 38 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.0001 1.5625C9.64982 1.5625 5.31258 5.89974 5.31258 11.25V12.1301C5.31258 13.0013 5.05472 13.8529 4.57149 14.5778L3.13574 16.7314C1.46937 19.231 2.7415 22.6285 5.63974 23.4189C6.58426 23.6765 7.53675 23.8944 8.49475 24.0726L8.49713 24.079C9.45837 26.6439 12.0275 28.4375 15 28.4375C17.9725 28.4375 20.5416 26.6439 21.5029 24.079L21.5052 24.0726C22.4633 23.8944 23.4158 23.6765 24.3604 23.4189C27.2587 22.6285 28.5308 19.231 26.8644 16.7314L25.4287 14.5778C24.9454 13.8529 24.6876 13.0013 24.6876 12.1301V11.25C24.6876 5.89974 20.3503 1.5625 15.0001 1.5625ZM19.2206 24.4212C16.4169 24.7562 13.5831 24.7562 10.7794 24.4212C11.6681 25.6981 13.2138 26.5625 15 26.5625C16.7862 26.5625 18.3319 25.6981 19.2206 24.4212ZM7.18758 11.25C7.18758 6.93528 10.6854 3.4375 15.0001 3.4375C19.3148 3.4375 22.8126 6.93528 22.8126 11.25V12.1301C22.8126 13.3715 23.18 14.585 23.8686 15.6178L25.3043 17.7715C26.2608 19.2062 25.5306 21.1563 23.8671 21.61C18.0618 23.1933 11.9384 23.1933 6.13308 21.61C4.46955 21.1563 3.73936 19.2062 4.69583 17.7715L6.13158 15.6178C6.82015 14.585 7.18758 13.3715 7.18758 12.1301V11.25Z"
                fill="#111111"
              />
              {/* <circle cx="26.5" cy="7" r="9" fill="var(--theme)" /><text transform="translate(20 11)">12</text> */}
            </svg>
          </NavLink>

          <NavLink to="/">
            <Stack direction="row" spacing={2}>
              <StyledBadge
                overlap="circular"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                badgeContent={status}
              >
                <Avatar
                  alt="Travis Howard"
                  id="avatar"
                  src={avatar}
                  sx={{ width: 50, height: 50 }}
                />
              </StyledBadge>
            </Stack>
          </NavLink>
        </div>
      </nav>
      <div className={`${navbar.extra_help}`} ref={help_text}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.75 16.25L10 10L16.25 16.25"
            stroke="#2D2D2B"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.75 10L10 3.75L16.25 10"
            stroke="#2D2D2B"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span>Yon panelni ochish uchun suring</span>
      </div>
      <div
        className={`${navbar.hide_background}  ${
          isSidebar || isColorD || isNotification || isTranslaterD
            ? navbar.active
            : ""
        }`}
        onClick={allClose}
      ></div>
      <div className={navbar.page_content} onClick={(e) => setSidebar(false)}>
        <aside className={`${isSidebar ? navbar.active : ""}`} ref={aside}>
          <div className="flex align-center flex-col">
            <NavLink id="RouterNavLink" to="/">
              <div className={`${navbar.logo_text} ${navbar.logo}`}>
                <svg
                  className={navbar.logo}
                  width="30"
                  height="25"
                  viewBox="0 0 30 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_189_79"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="30"
                    height="25"
                  >
                    <path d="M30 0H0V24.9622H30V0Z" fill="white" />
                  </mask>
                  <g>
                    <path
                      d="M6.765 4.3463V18.5195C6.75574 19.4105 6.39527 20.2619 5.76194 20.8886C5.12861 21.5154 4.27354 21.867 3.3825 21.867C2.49145 21.867 1.63639 21.5154 1.00305 20.8886C0.369717 20.2619 0.00926656 19.4105 0 18.5195V4.3463C0.000582015 3.4493 0.357428 2.58924 0.992056 1.9553C1.62669 1.32135 2.48713 0.965437 3.38415 0.965824C3.94511 0.964335 4.4974 1.10399 4.99024 1.37193C4.99793 1.37522 5.00122 1.37924 5.00488 1.37924C5.00678 1.38133 5.00938 1.38263 5.0122 1.3829C5.2927 1.53594 5.54912 1.72949 5.77317 1.95729C6.08766 2.27059 6.33713 2.6429 6.50737 3.05288C6.67756 3.46286 6.76511 3.90241 6.765 4.3463Z"
                      fill="#6285FF"
                    />
                    <path
                      d="M14.4951 7.40854V21.578C14.4951 22.0222 14.4076 22.4621 14.2376 22.8724C14.0676 23.2828 13.8185 23.6556 13.5044 23.9697C13.1904 24.2838 12.8175 24.5329 12.4071 24.7029C11.9968 24.8729 11.557 24.9604 11.1128 24.9604C10.6686 24.9604 10.2288 24.8729 9.81843 24.7029C9.40805 24.5329 9.03521 24.2838 8.72113 23.9697C8.40704 23.6556 8.1579 23.2828 7.98792 22.8724C7.81794 22.4621 7.73047 22.0222 7.73047 21.578V7.40854C7.73036 6.9641 7.81783 6.52398 7.98788 6.11338C8.1579 5.70274 8.40719 5.32965 8.72146 5.01538C9.03572 4.70111 9.40882 4.45182 9.81942 4.28181C10.2301 4.11176 10.6702 4.02428 11.1146 4.02439C11.2353 4.02439 11.3524 4.03171 11.4658 4.04232H11.4735C12.3033 4.13254 13.0707 4.52598 13.6283 5.14712C14.1859 5.76827 14.4946 6.57381 14.4951 7.40854Z"
                      fill="#6285FF"
                    />
                    <path
                      d="M22.2695 3.38045V17.5536C22.2695 18.4507 21.9132 19.311 21.2789 19.9453C20.6445 20.5796 19.7842 20.9359 18.8872 20.9359C17.9902 20.9359 17.1299 20.5796 16.4955 19.9453C15.8612 19.311 15.5049 18.4507 15.5049 17.5536V3.38045C15.5049 2.93621 15.5924 2.49632 15.7626 2.08594C15.9327 1.67557 16.182 1.30274 16.4963 0.988785C16.8106 0.674831 17.1837 0.425904 17.5942 0.256233C18.0048 0.0865625 18.4448 -0.000521894 18.889 -4.11141e-05C19.0286 -0.00147909 19.1681 0.00830851 19.3061 0.0292271H19.3134C20.0573 0.11923 20.7493 0.456848 21.2781 0.987764C21.5925 1.30178 21.842 1.67475 22.0121 2.08533C22.1823 2.49591 22.2697 2.93602 22.2695 3.38045Z"
                      fill="#6285FF"
                    />
                    <path
                      d="M29.9999 7.24716V21.417C29.9999 21.8612 29.9124 22.301 29.7424 22.7114C29.5724 23.1218 29.3233 23.4946 29.0092 23.8087C28.6951 24.1228 28.3222 24.3719 27.9119 24.5419C27.5015 24.7119 27.0617 24.7994 26.6175 24.7994C26.1734 24.7994 25.7335 24.7119 25.3232 24.5419C24.9128 24.3719 24.5399 24.1228 24.2259 23.8087C23.9118 23.4946 23.6627 23.1218 23.4927 22.7114C23.3227 22.301 23.2352 21.8612 23.2352 21.417V7.24716C23.2352 6.80272 23.3227 6.36267 23.4927 5.95204C23.6628 5.54144 23.9121 5.16834 24.2263 4.85411C24.5406 4.53984 24.9137 4.29058 25.3243 4.12054C25.7349 3.95049 26.1749 3.86297 26.6194 3.86301C27.067 3.86118 27.5102 3.95096 27.9218 4.12679H27.9255C27.9274 4.12888 27.93 4.13019 27.9328 4.13045C28.3355 4.29874 28.701 4.54493 29.0084 4.85484C29.3238 5.16808 29.5739 5.54089 29.7441 5.95156C29.9143 6.36223 30.0012 6.80261 29.9999 7.24716Z"
                      fill="url(#paint0_linear_189_79)"
                    />
                    <g opacity="0.3">
                      <path
                        d="M6.765 8.42554V18.5194C6.75574 19.4104 6.39527 20.2618 5.76194 20.8886C5.12861 21.5154 4.27354 21.8669 3.3825 21.8669C2.49145 21.8669 1.63639 21.5154 1.00305 20.8886C0.369717 20.2618 0.00926656 19.4104 0 18.5194V17.9377C0 17.9377 0.00731759 18.0215 0.0219517 18.1752C0.0292688 18.3325 0.0512199 18.5633 0.0881711 18.8447C0.1505 19.18 0.258712 19.5051 0.409756 19.8109C0.676815 20.3541 1.09264 20.8102 1.60885 21.1263C2.12505 21.4424 2.7204 21.6053 3.32561 21.5963C3.60008 21.5934 3.87304 21.5553 4.1378 21.4829C4.69712 21.3254 5.20141 21.015 5.5939 20.5865C5.99583 20.1506 6.26049 19.606 6.35488 19.0207C6.3622 18.9475 6.38049 18.889 6.38415 18.8048L6.39915 18.556C6.4061 18.428 6.40244 18.2341 6.4061 18.0768C6.4061 17.7475 6.40976 17.4146 6.41341 17.089C6.41341 16.4341 6.43537 15.7902 6.44305 15.1646C6.46829 13.917 6.50854 12.7532 6.5561 11.7548C6.64427 9.75724 6.765 8.42554 6.765 8.42554Z"
                        fill="#6285FF"
                      />
                    </g>
                    <g opacity="0.6">
                      <path
                        d="M5.00524 1.37927C4.87804 1.3378 4.74856 1.3036 4.61744 1.27683C4.27943 1.19848 3.93234 1.16648 3.58573 1.18171C3.47673 1.18577 3.36809 1.19677 3.26049 1.21463C3.14714 1.22856 3.03474 1.24933 2.9239 1.27683C2.16918 1.44753 1.49608 1.8725 1.01744 2.48049C0.850584 2.68494 0.710437 2.90979 0.600366 3.14963C0.495282 3.38184 0.415555 3.62471 0.362561 3.87402C0.335648 4.00086 0.31598 4.1291 0.303658 4.25817L0.292683 4.35695C0.292683 4.36061 0.289024 4.41549 0.285365 4.4411C0.281707 4.50695 0.278049 4.5728 0.271098 4.635C0.256098 4.8911 0.230488 5.13256 0.208537 5.35573C0.16396 5.85402 0.0943602 6.34979 0 6.8411V4.34597C0.000675505 3.75914 0.153928 3.18261 0.444713 2.67291C0.735498 2.16321 1.15382 1.73789 1.65862 1.43868C2.16342 1.13948 2.73735 0.976674 3.32407 0.966258C3.91079 0.955842 4.49012 1.09817 5.00524 1.37927Z"
                        fill="#6285FF"
                      />
                    </g>
                    <g opacity="0.3">
                      <path
                        d="M14.4951 11.4728V21.578C14.4951 22.0222 14.4076 22.462 14.2376 22.8724C14.0676 23.2827 13.8185 23.6556 13.5044 23.9697C13.1904 24.2838 12.8175 24.5329 12.4071 24.7029C11.9968 24.8729 11.557 24.9603 11.1128 24.9603C10.6686 24.9603 10.2288 24.8729 9.81843 24.7029C9.40805 24.5329 9.03521 24.2838 8.72113 23.9697C8.40704 23.6556 8.1579 23.2827 7.98792 22.8724C7.81794 22.462 7.73047 22.0222 7.73047 21.578V21.1683C7.73047 21.1683 7.73779 21.2524 7.75242 21.4057C7.76537 21.6273 7.79596 21.8475 7.84388 22.0642C8.0091 22.8176 8.42907 23.4909 9.03291 23.9707C9.42419 24.2788 9.88107 24.4928 10.3683 24.5963C10.4928 24.6215 10.6186 24.6398 10.7451 24.6512C10.8839 24.6607 11.0231 24.6632 11.1622 24.6585C11.4378 24.6434 11.7106 24.5954 11.9747 24.5155C12.5219 24.336 13.01 24.0109 13.3866 23.5752C13.7728 23.1321 14.0197 22.5848 14.0963 22.002C14.1179 21.8517 14.1301 21.7002 14.1329 21.5484L14.1366 21.0541C14.1366 20.7248 14.1402 20.3956 14.1442 20.0703C14.1442 19.4228 14.1658 18.7825 14.1735 18.1606C14.1988 16.9236 14.239 15.7679 14.2866 14.7764C14.3744 12.7939 14.4951 11.4728 14.4951 11.4728Z"
                        fill="#6285FF"
                      />
                    </g>
                    <g opacity="0.6">
                      <path
                        d="M11.4658 4.04232C11.4329 4.05 11.3049 4.06829 11.1036 4.09756C10.9902 4.12683 10.8516 4.14878 10.7012 4.19268C10.5333 4.24167 10.3685 4.30017 10.2073 4.36793C10.0224 4.4497 9.84382 4.54522 9.67315 4.65366C9.48883 4.77575 9.31396 4.91148 9.14998 5.05976C8.98257 5.22209 8.83066 5.39967 8.69632 5.59024C8.55807 5.78356 8.44033 5.99078 8.3451 6.20854C8.25232 6.42659 8.18135 6.65331 8.13327 6.88537C8.10872 7.00138 8.09029 7.11864 8.07803 7.23659L8.05974 7.41183L8.05242 7.60244C8.02681 8.10366 7.98657 8.57159 7.93901 8.97439C7.89444 9.42549 7.82482 9.87373 7.73047 10.3171V7.40854C7.73036 6.9641 7.81783 6.52398 7.98788 6.11338C8.1579 5.70274 8.40719 5.32965 8.72146 5.01538C9.03572 4.70111 9.40882 4.45182 9.81942 4.28181C10.2301 4.11176 10.6702 4.02428 11.1146 4.02439C11.2353 4.02439 11.3524 4.03171 11.4658 4.04232Z"
                        fill="#6285FF"
                      />
                    </g>
                    <g opacity="0.3">
                      <path
                        d="M22.2695 4.82927V17.5536C22.2695 18.4507 21.9132 19.311 21.2789 19.9453C20.6445 20.5796 19.7842 20.936 18.8872 20.936C17.9902 20.936 17.1299 20.5796 16.4955 19.9453C15.8612 19.311 15.5049 18.4507 15.5049 17.5536V17.2683C15.5049 17.2683 15.5122 17.3598 15.5268 17.5317C15.5467 17.7779 15.5895 18.0216 15.6549 18.2598C15.7601 18.6226 15.9259 18.9651 16.1451 19.2728C16.4202 19.6657 16.7788 19.9931 17.1951 20.2313C17.6784 20.5119 18.2277 20.6585 18.7866 20.6561C19.0828 20.6594 19.3778 20.6175 19.6613 20.5317C19.9597 20.4489 20.2436 20.3205 20.5028 20.1512C21.0422 19.797 21.4588 19.2845 21.6955 18.6841L21.7796 18.4573L21.8382 18.2191C21.8601 18.139 21.8638 18.0622 21.8784 17.9854C21.8941 17.9021 21.9015 17.8176 21.9004 17.7329C21.9187 17.4036 21.9004 17.0049 21.904 16.6463C21.9077 15.9073 21.9113 15.1683 21.9187 14.4402C21.9187 13.7122 21.9406 12.9988 21.9479 12.3073C21.9735 10.9207 22.0138 9.62923 22.0613 8.5207C22.1488 6.30362 22.2695 4.82927 22.2695 4.82927Z"
                        fill="#6285FF"
                      />
                    </g>
                    <g opacity="0.6">
                      <path
                        d="M19.3061 0.0292271C19.2585 0.0365442 19.1378 0.0548368 18.9585 0.076788C18.8488 0.0841051 18.7061 0.1313 18.5524 0.15691C18.3839 0.203439 18.2178 0.25851 18.0549 0.32191C17.8679 0.399855 17.6869 0.491571 17.5134 0.596301C17.3242 0.712002 17.1456 0.844225 16.9796 0.991422C16.8915 1.06459 16.8146 1.1524 16.7345 1.23289C16.6613 1.32801 16.5768 1.41179 16.511 1.51093C16.368 1.70173 16.2465 1.90774 16.1488 2.1252C16.0478 2.34071 15.9705 2.56654 15.9183 2.79874C15.9037 2.91581 15.8671 3.00362 15.8561 3.14264L15.8378 3.33252L15.8342 3.38045V3.38411L15.8305 3.3874V3.41337L15.8268 3.5085C15.8012 4.01338 15.761 4.48167 15.7134 4.88411C15.669 5.33641 15.5993 5.7859 15.5049 6.23045V3.38045C15.5049 2.93621 15.5924 2.49632 15.7626 2.08594C15.9327 1.67557 16.182 1.30274 16.4963 0.988785C16.8106 0.674831 17.1837 0.425904 17.5942 0.256233C18.0048 0.0865625 18.4448 -0.000521894 18.889 -4.11141e-05C19.0286 -0.00147909 19.1681 0.00830851 19.3061 0.0292271Z"
                        fill="#6285FF"
                      />
                    </g>
                    <g opacity="0.6">
                      <path
                        d="M27.9218 4.12679C27.8889 4.11911 27.7572 4.0935 27.5486 4.06825C27.4279 4.05362 27.2816 4.04594 27.1169 4.04228C26.9335 4.04158 26.7502 4.05271 26.5682 4.07557C26.3581 4.10685 26.1503 4.15196 25.9462 4.21057C25.7263 4.28151 25.5132 4.37224 25.3096 4.48167C24.8746 4.71973 24.4964 5.04926 24.2011 5.44752C24.05 5.64688 23.9223 5.86291 23.8206 6.09143C23.7226 6.31236 23.6478 6.54285 23.5974 6.77923C23.5701 6.89843 23.5517 7.01949 23.5425 7.14143L23.5316 7.23289L23.5279 7.25118L23.5243 7.26545L23.5206 7.31338C23.5169 7.37557 23.5133 7.43411 23.5096 7.4963C23.4913 7.73777 23.4694 7.96825 23.4438 8.17679C23.3994 8.64969 23.3297 9.11985 23.2352 9.58533V7.24716C23.2352 6.80272 23.3227 6.36267 23.4927 5.95204C23.6628 5.54144 23.9121 5.16834 24.2263 4.85411C24.5406 4.53984 24.9137 4.29058 25.3243 4.12054C25.7349 3.95049 26.1749 3.86297 26.6194 3.86301C27.067 3.86118 27.5102 3.95096 27.9218 4.12679Z"
                        fill="#6285FF"
                      />
                    </g>
                    <g opacity="0.3">
                      <path
                        d="M29.9999 12.3293V21.4171C29.9999 21.8612 29.9124 22.3011 29.7424 22.7114C29.5724 23.1218 29.3233 23.4946 29.0092 23.8087C28.6951 24.1228 28.3222 24.3719 27.9119 24.5419C27.5015 24.7119 27.0617 24.7994 26.6175 24.7994C26.1734 24.7994 25.7335 24.7119 25.3232 24.5419C24.9128 24.3719 24.5399 24.1228 24.2259 23.8087C23.9118 23.4946 23.6627 23.1218 23.4927 22.7114C23.3227 22.3011 23.2352 21.8612 23.2352 21.4171C23.2352 21.4171 23.2462 21.4939 23.2682 21.6402C23.2774 21.727 23.2945 21.8127 23.3194 21.8963C23.342 22.0121 23.3738 22.1258 23.4145 22.2366C23.6001 22.7979 23.9323 23.2994 24.3768 23.6892C24.8212 24.079 25.3618 24.3429 25.9425 24.4537C26.0633 24.4756 26.1767 24.4829 26.2974 24.4976L26.5023 24.5012H26.6377L26.6852 24.4939C26.9432 24.4805 27.1987 24.4362 27.4462 24.3622C27.9579 24.2037 28.4203 23.9164 28.7889 23.5277C28.9768 23.328 29.139 23.1057 29.2718 22.8659C29.3979 22.6227 29.4926 22.3646 29.5535 22.0976C29.5862 21.9677 29.6094 21.8356 29.623 21.7024L29.6377 21.4756V21.4171L29.6413 21.3765V21.2634C29.6413 20.9561 29.645 20.6484 29.6486 20.3451C29.6486 19.7415 29.6706 19.1415 29.6779 18.5671C29.7035 17.411 29.7438 16.3317 29.7913 15.4098C29.8791 13.5582 29.9999 12.3293 29.9999 12.3293Z"
                        fill="#6285FF"
                      />
                    </g>
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear_189_79"
                      x1="26.6175"
                      y1="4.34451"
                      x2="26.6175"
                      y2="25.5531"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#6285FF" />
                      <stop offset="1" stopColor="#6285FF" />
                    </linearGradient>
                  </defs>
                </svg>
                <span>BrainCore</span>
              </div>
            </NavLink>
            <div className={navbar.nav_items}>
              <div className={navbar.controllers}>
                <div onClick={switchTheme}>
                  {browseTheme ? (
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.556 9.88071L17.1281 9.62212V9.62212L17.556 9.88071ZM10.1193 2.44397L9.8607 2.01603V2.01603L10.1193 2.44397ZM17.8333 10C17.8333 14.3262 14.3262 17.8333 9.99999 17.8333V18.8333C14.8785 18.8333 18.8333 14.8785 18.8333 10H17.8333ZM9.99999 17.8333C5.67376 17.8333 2.16666 14.3262 2.16666 10H1.16666C1.16666 14.8785 5.12147 18.8333 9.99999 18.8333V17.8333ZM2.16666 10C2.16666 5.67377 5.67376 2.16667 9.99999 2.16667V1.16667C5.12147 1.16667 1.16666 5.12149 1.16666 10H2.16666ZM12.9167 12C10.2013 12 7.99999 9.79874 7.99999 7.08334H6.99999C6.99999 10.351 9.64897 13 12.9167 13V12ZM17.1281 9.62212C16.2663 11.0483 14.7024 12 12.9167 12V13C15.0669 13 16.9486 11.8527 17.984 10.1393L17.1281 9.62212ZM7.99999 7.08334C7.99999 5.29763 8.95166 3.73372 10.3779 2.87191L9.8607 2.01603C8.14728 3.05138 6.99999 4.93314 6.99999 7.08334H7.99999ZM9.99999 2.16667C9.98457 2.16667 9.96068 2.16352 9.93336 2.15188C9.90622 2.14031 9.8838 2.12382 9.86713 2.10648C9.8356 2.07366 9.83248 2.04747 9.83248 2.04746C9.83232 2.04625 9.83205 2.04727 9.83285 2.04537C9.83471 2.04092 9.84263 2.02695 9.8607 2.01603L10.3779 2.87191C10.7463 2.64929 10.8675 2.23931 10.8235 1.91362C10.7779 1.5764 10.5163 1.16667 9.99999 1.16667V2.16667ZM17.984 10.1393C17.973 10.1574 17.9591 10.1653 17.9546 10.1671C17.9527 10.1679 17.9537 10.1677 17.9525 10.1675C17.9525 10.1675 17.9263 10.1644 17.8935 10.1329C17.8762 10.1162 17.8597 10.0938 17.8481 10.0666C17.8365 10.0393 17.8333 10.0154 17.8333 10H18.8333C18.8333 9.48369 18.4236 9.22205 18.0864 9.17651C17.7607 9.13253 17.3507 9.25371 17.1281 9.62212L17.984 10.1393Z"
                        fill="#090909"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="10" cy="9.99999" r="4.16667" stroke="white" />
                      <path
                        d="M10 1.66667V3.33334"
                        stroke="white"
                        strokeLinecap="round"
                      />
                      <path
                        d="M10 16.6667V18.3333"
                        stroke="white"
                        strokeLinecap="round"
                      />
                      <path
                        d="M3.33334 10L1.66668 10"
                        stroke="white"
                        strokeLinecap="round"
                      />
                      <path
                        d="M18.3333 10L16.6667 10"
                        stroke="white"
                        strokeLinecap="round"
                      />
                      <path
                        d="M16.4815 3.51848L14.6299 5.21147"
                        stroke="white"
                        strokeLinecap="round"
                      />
                      <path
                        d="M3.51846 3.51848L5.37014 5.21147"
                        stroke="white"
                        strokeLinecap="round"
                      />
                      <path
                        d="M5.37027 14.6297L3.51842 16.4816"
                        stroke="white"
                        strokeLinecap="round"
                      />
                      <path
                        d="M16.4815 16.4815L14.6299 14.6296"
                        stroke="white"
                        strokeLinecap="round"
                      />
                    </svg>
                  )}
                </div>
                <div onClick={() => setColorD((current) => !current)}>
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M15 3.4375C8.61651 3.4375 3.4375 8.62651 3.4375 15.0326C3.4375 20.9856 7.91076 25.889 13.6657 26.5515C14.2438 26.618 14.8625 26.3755 15.3572 25.8795C15.8091 25.4265 15.8091 24.691 15.3572 24.238C14.9673 23.847 14.5763 23.3261 14.3624 22.734C14.1433 22.1275 14.0891 21.3666 14.5337 20.6595C14.9374 20.0175 15.5426 19.6738 16.1776 19.5067C16.7891 19.3458 17.4667 19.3367 18.1175 19.3762C18.7225 19.4129 19.3738 19.4973 20.0056 19.5792C20.0589 19.5861 20.112 19.593 20.165 19.5998C20.8611 19.6897 21.5409 19.7734 22.1976 19.8049C23.5405 19.8693 24.5749 19.7 25.2818 19.1221C25.9583 18.569 26.5625 17.446 26.5625 15.0326C26.5625 8.62651 21.3835 3.4375 15 3.4375ZM1.5625 15.0326C1.5625 7.59559 7.57637 1.5625 15 1.5625C22.4236 1.5625 28.4375 7.59559 28.4375 15.0326C28.4375 17.7142 27.7664 19.5126 26.4685 20.5737C25.201 21.6099 23.5618 21.7475 22.1078 21.6778C21.3661 21.6422 20.6167 21.5487 19.9249 21.4594C19.8763 21.4531 19.8281 21.4468 19.7802 21.4406C19.1307 21.3566 18.5419 21.2804 18.004 21.2477C17.4213 21.2124 16.9785 21.2348 16.6548 21.3199C16.3547 21.3989 16.21 21.5159 16.121 21.6575C16.0725 21.7346 16.0383 21.8547 16.1259 22.0969C16.2186 22.3537 16.421 22.6493 16.6848 22.9139C17.8666 24.0987 17.8666 26.0188 16.6848 27.2036C15.872 28.0186 14.7102 28.5591 13.4513 28.4142C6.75706 27.6435 1.5625 21.9453 1.5625 15.0326ZM11.9813 7.81221C11.4635 7.81221 11.0438 8.23195 11.0438 8.74971C11.0438 9.26748 11.4635 9.68721 11.9813 9.68721C12.499 9.68721 12.9188 9.26748 12.9188 8.74971C12.9188 8.23195 12.499 7.81221 11.9813 7.81221ZM9.16875 8.74971C9.16875 7.19641 10.428 5.93721 11.9813 5.93721C13.5346 5.93721 14.7938 7.19641 14.7938 8.74971C14.7938 10.303 13.5346 11.5622 11.9813 11.5622C10.428 11.5622 9.16875 10.303 9.16875 8.74971ZM18.125 7.8125C17.6072 7.8125 17.1875 8.23223 17.1875 8.75C17.1875 9.26777 17.6072 9.6875 18.125 9.6875C18.6428 9.6875 19.0625 9.26777 19.0625 8.75C19.0625 8.23223 18.6428 7.8125 18.125 7.8125ZM15.3125 8.75C15.3125 7.1967 16.5717 5.9375 18.125 5.9375C19.6783 5.9375 20.9375 7.1967 20.9375 8.75C20.9375 10.3033 19.6783 11.5625 18.125 11.5625C16.5717 11.5625 15.3125 10.3033 15.3125 8.75ZM8.125 13.4375C7.60723 13.4375 7.1875 13.8572 7.1875 14.375C7.1875 14.8928 7.60723 15.3125 8.125 15.3125C8.64277 15.3125 9.0625 14.8928 9.0625 14.375C9.0625 13.8572 8.64277 13.4375 8.125 13.4375ZM5.3125 14.375C5.3125 12.8217 6.5717 11.5625 8.125 11.5625C9.6783 11.5625 10.9375 12.8217 10.9375 14.375C10.9375 15.9283 9.6783 17.1875 8.125 17.1875C6.5717 17.1875 5.3125 15.9283 5.3125 14.375ZM21.875 13.4375C21.3572 13.4375 20.9375 13.8572 20.9375 14.375C20.9375 14.8928 21.3572 15.3125 21.875 15.3125C22.3928 15.3125 22.8125 14.8928 22.8125 14.375C22.8125 13.8572 22.3928 13.4375 21.875 13.4375ZM19.0625 14.375C19.0625 12.8217 20.3217 11.5625 21.875 11.5625C23.4283 11.5625 24.6875 12.8217 24.6875 14.375C24.6875 15.9283 23.4283 17.1875 21.875 17.1875C20.3217 17.1875 19.0625 15.9283 19.0625 14.375Z"
                      fill="#111111"
                    />
                  </svg>
                </div>
                <NavLink to={"/messages/"}>
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 -3 38 38"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M15.0001 1.5625C9.64982 1.5625 5.31258 5.89974 5.31258 11.25V12.1301C5.31258 13.0013 5.05472 13.8529 4.57149 14.5778L3.13574 16.7314C1.46937 19.231 2.7415 22.6285 5.63974 23.4189C6.58426 23.6765 7.53675 23.8944 8.49475 24.0726L8.49713 24.079C9.45837 26.6439 12.0275 28.4375 15 28.4375C17.9725 28.4375 20.5416 26.6439 21.5029 24.079L21.5052 24.0726C22.4633 23.8944 23.4158 23.6765 24.3604 23.4189C27.2587 22.6285 28.5308 19.231 26.8644 16.7314L25.4287 14.5778C24.9454 13.8529 24.6876 13.0013 24.6876 12.1301V11.25C24.6876 5.89974 20.3503 1.5625 15.0001 1.5625ZM19.2206 24.4212C16.4169 24.7562 13.5831 24.7562 10.7794 24.4212C11.6681 25.6981 13.2138 26.5625 15 26.5625C16.7862 26.5625 18.3319 25.6981 19.2206 24.4212ZM7.18758 11.25C7.18758 6.93528 10.6854 3.4375 15.0001 3.4375C19.3148 3.4375 22.8126 6.93528 22.8126 11.25V12.1301C22.8126 13.3715 23.18 14.585 23.8686 15.6178L25.3043 17.7715C26.2608 19.2062 25.5306 21.1563 23.8671 21.61C18.0618 23.1933 11.9384 23.1933 6.13308 21.61C4.46955 21.1563 3.73936 19.2062 4.69583 17.7715L6.13158 15.6178C6.82015 14.585 7.18758 13.3715 7.18758 12.1301V11.25Z"
                      fill="#111111"
                    />
                    {/* <circle cx="26.5" cy="7" r="9" fill="#3E6EFF" /><text transform="translate(20 11)">12</text> */}
                  </svg>
                </NavLink>
                <div onClick={() => setTranslaterD((current) => !current)}>
                  <svg
                    className={navbar.stroke}
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                  >
                    <path
                      d="M29 27L22 13L15 27"
                      stroke="black"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M17 23H27"
                      stroke="black"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M11 4V7"
                      stroke="black"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3 7H19"
                      stroke="black"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M15 7C15 10.1826 13.7357 13.2348 11.4853 15.4853C9.23484 17.7357 6.1826 19 3 19"
                      stroke="black"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M7.68359 11.0001C8.51222 13.3388 10.0451 15.3634 12.0715 16.7952C14.0979 18.227 16.5181 18.9958 18.9993 18.9958"
                      stroke="black"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
              <NavLink
                id="RouterNavLink"
                to="/"
                className={({ isActive }) =>
                  isActive ? `${navbar.active}` : ""
                }
              >
                <svg
                  className={navbar.color_storke}
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.75 11.25L15 2.5L26.25 11.25V25C26.25 25.663 25.9866 26.2989 25.5178 26.7678C25.0489 27.2366 24.413 27.5 23.75 27.5H6.25C5.58696 27.5 4.95107 27.2366 4.48223 26.7678C4.01339 26.2989 3.75 25.663 3.75 25V11.25Z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M11.25 27.5V15H18.75V27.5"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span>Bosh sahifa</span>
              </NavLink>
              {who?.includes("0") || who?.includes("1") ? (
                <>
                  <NavLink
                    id="RouterNavLink"
                    to="/reception"
                    className={({ isActive }) =>
                      isActive ? `${navbar.active}` : ""
                    }
                  >
                    <svg
                      className={navbar.color_fill}
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M26.4727 6.83321L15.2227 3.0832C15.0781 3.03496 14.9219 3.03496 14.7773 3.0832L3.52734 6.83321C3.38744 6.87991 3.26577 6.96943 3.17954 7.08909C3.09332 7.20876 3.04691 7.35251 3.04688 7.5V16.875C3.04688 17.0615 3.12095 17.2403 3.25282 17.3722C3.38468 17.504 3.56352 17.5781 3.75 17.5781C3.93648 17.5781 4.11532 17.504 4.24718 17.3722C4.37905 17.2403 4.45312 17.0615 4.45312 16.875V8.475L8.98594 9.98672C8.41433 10.8315 8.02699 11.7871 7.84912 12.7915C7.67125 13.7958 7.70683 14.8263 7.95356 15.816C8.20029 16.8057 8.65264 17.7324 9.28116 18.5357C9.90968 19.339 10.7003 20.001 11.6016 20.4785C9.3457 21.2438 7.38281 22.7742 5.97656 24.9316C5.89573 25.0865 5.87541 25.2658 5.91956 25.4348C5.96371 25.6038 6.06918 25.7503 6.21541 25.8458C6.36165 25.9413 6.53819 25.9789 6.71066 25.9514C6.88314 25.9239 7.03919 25.8331 7.14844 25.6969C8.96133 22.9207 11.8219 21.3281 15 21.3281C18.1781 21.3281 21.0387 22.9207 22.8516 25.6969C22.9601 25.836 23.1171 25.9293 23.2912 25.9581C23.4654 25.9868 23.644 25.9491 23.7916 25.8523C23.9392 25.7554 24.0449 25.6067 24.0879 25.4354C24.1308 25.2642 24.1078 25.0831 24.0234 24.9281C22.6172 22.7742 20.6566 21.2438 18.3984 20.475C19.2992 19.9969 20.0893 19.3346 20.7172 18.531C21.3451 17.7275 21.7969 16.8007 22.043 15.8111C22.2892 14.8215 22.3243 13.7911 22.146 12.787C21.9677 11.7829 21.58 10.8276 21.0082 9.98321L26.4727 8.1668C26.6125 8.12002 26.7341 8.03047 26.8202 7.91081C26.9063 7.79115 26.9527 7.64744 26.9527 7.5C26.9527 7.35256 26.9063 7.20885 26.8202 7.08919C26.7341 6.96953 26.6125 6.87998 26.4727 6.83321ZM20.8594 14.0625C20.8598 14.9962 20.6371 15.9164 20.2098 16.7466C19.7825 17.5767 19.163 18.2928 18.403 18.835C17.6429 19.3773 16.7642 19.73 15.8402 19.8639C14.9162 19.9978 13.9736 19.9089 13.0909 19.6047C12.2081 19.3005 11.4109 18.7897 10.7656 18.115C10.1202 17.4403 9.64547 16.6211 9.38086 15.7257C9.11625 14.8303 9.06945 13.8846 9.24434 12.9675C9.41924 12.0504 9.81078 11.1883 10.3863 10.4531L14.7773 11.9168C14.9219 11.965 15.0781 11.965 15.2227 11.9168L19.6137 10.4531C20.422 11.4824 20.8608 12.7537 20.8594 14.0625ZM15 10.5094L5.97656 7.5L15 4.49063L24.0234 7.5L15 10.5094Z"
                        fill="#2B2B2B"
                      />
                    </svg>
                    <span>Qabulxona</span>
                  </NavLink>
                  <NavLink
                    id="RouterNavLink"
                    to="/teacher"
                    className={({ isActive }) =>
                      isActive ? `${navbar.active}` : ""
                    }
                  >
                    <svg
                      className={navbar.color_fill}
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15 15C17.7625 15 20 12.7625 20 10C20 7.2375 17.7625 5 15 5C12.2375 5 10 7.2375 10 10C10 12.7625 12.2375 15 15 15ZM21.25 10C21.25 13.4531 18.4531 16.25 15 16.25C11.5469 16.25 8.75 13.4531 8.75 10C8.75 6.54688 11.5469 3.75 15 3.75C18.4531 3.75 21.25 6.54688 21.25 10ZM5.76437 21.3825C5.1375 21.8888 5 22.2681 5 22.5V25H25V22.5C25 22.2687 24.8625 21.8881 24.235 21.3825C23.6225 20.8881 22.7087 20.4169 21.6012 20.0094C19.3875 19.195 16.7206 18.75 15 18.75C13.2794 18.75 10.6125 19.195 8.39875 20.0094C7.29125 20.4169 6.3775 20.8881 5.76437 21.3825ZM15 17.5C11.245 17.5 3.75 19.3969 3.75 22.5V26.25H26.25V22.5C26.25 19.3969 18.755 17.5 15 17.5Z"
                        fill="#2B2B2B"
                      />
                    </svg>

                    <span>O'qituvchilar</span>
                  </NavLink>
                  <NavLink
                    id="RouterNavLink"
                    to="/groups"
                    className={({ isActive }) =>
                      isActive ? `${navbar.active}` : ""
                    }
                  >
                    <svg
                      className={navbar.color_fill}
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.8304 3.52572C13.8588 2.57476 16.1411 2.57476 18.1695 3.52572L26.5335 7.44695C27.8488 8.06363 28.4375 9.40278 28.4375 10.625C28.4375 11.8473 27.8488 13.1864 26.5335 13.8031L24.6875 14.6685V20.7818C24.6875 22.3481 23.9022 23.8603 22.4725 24.6521C21.5329 25.1725 20.298 25.7989 18.9985 26.2975C17.7144 26.7901 16.2924 27.1875 15 27.1875C13.7076 27.1875 12.2856 26.7901 11.0015 26.2975C9.70198 25.7989 8.46713 25.1725 7.52748 24.6521C6.09782 23.8603 5.3125 22.3481 5.3125 20.7818V14.6685L3.46654 13.803L3.4375 13.7893V17.5C3.4375 18.0178 3.01777 18.4375 2.5 18.4375C1.98223 18.4375 1.5625 18.0178 1.5625 17.5V10.625C1.5625 9.40275 2.15118 8.06357 3.46655 7.4469L11.8304 3.52572ZM7.1875 15.5475V20.7818C7.1875 21.7355 7.66094 22.5827 8.43585 23.0118C9.33166 23.5079 10.4835 24.0905 11.6731 24.5469C12.8779 25.0091 14.0474 25.3125 15 25.3125C15.9526 25.3125 17.1221 25.0091 18.3269 24.5469C19.5165 24.0905 20.6683 23.5079 21.5641 23.0118C22.3391 22.5827 22.8125 21.7355 22.8125 20.7818V15.5476L18.1696 17.7243C16.1412 18.6752 13.8589 18.6752 11.8305 17.7243L7.1875 15.5475ZM4.26246 12.1054C3.75848 11.8691 3.4375 11.3055 3.4375 10.625C3.4375 9.94447 3.75849 9.38086 4.26246 9.14459L12.6264 5.22341C14.1505 4.50886 15.8494 4.50886 17.3735 5.22341L25.7375 9.14464C26.2415 9.38091 26.5625 9.94452 26.5625 10.625C26.5625 11.3055 26.2415 11.8691 25.7375 12.1054L17.3736 16.0266C15.8495 16.7411 14.1506 16.7411 12.6265 16.0266L4.26246 12.1054Z"
                        fill="#2B2B2B"
                      />
                    </svg>

                    <span>Sinflar</span>
                  </NavLink>
                  <NavLink
                    id="RouterNavLink"
                    to="/budget"
                    className={({ isActive }) =>
                      isActive ? `${navbar.active}` : ""
                    }
                  >
                    <svg
                      className={navbar.color_storke}
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="15"
                        cy="15"
                        r="12.5"
                        stroke="#2B2B2B"
                        strokeWidth="1.5"
                      />
                      <path
                        d="M15 21.25V21.875V22.5"
                        stroke="#2B2B2B"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M15 7.5V8.125V8.75"
                        stroke="#2B2B2B"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M18.75 11.875C18.75 10.1491 17.0711 8.75 15 8.75C12.9289 8.75 11.25 10.1491 11.25 11.875C11.25 13.6009 12.9289 15 15 15C17.0711 15 18.75 16.3991 18.75 18.125C18.75 19.8509 17.0711 21.25 15 21.25C12.9289 21.25 11.25 19.8509 11.25 18.125"
                        stroke="#2B2B2B"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                    </svg>

                    <span>Budjet</span>
                  </NavLink>
                  <NavLink
                    id="RouterNavLink"
                    to="/get-payment"
                    className={({ isActive }) =>
                      isActive ? `${navbar.active}` : ""
                    }
                  >
                    <i className="fa-solid fa-money-check-dollar-pen text-2xl "></i>
                    <span>To'lov olish</span>
                  </NavLink>

                  <NavLink
                    id="RouterNavLink"
                    to="/lessons"
                    className={({ isActive }) =>
                      isActive ? `${navbar.active}` : ""
                    }
                  >
                    <svg
                      className={navbar.color_fill}
                      width="27"
                      height="28"
                      viewBox="0 0 27 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.1814 0.562501H17.8186C19.5281 0.562475 20.906 0.562454 21.9897 0.708155C23.1148 0.859425 24.0622 1.18304 24.8146 1.93544C25.567 2.68783 25.8906 3.63518 26.0418 4.76031C26.1875 5.84402 26.1875 7.22192 26.1875 8.93141V19.0686C26.1875 20.7781 26.1875 22.156 26.0418 23.2397C25.8906 24.3648 25.567 25.3122 24.8146 26.0646C24.0622 26.817 23.1148 27.1406 21.9897 27.2919C20.906 27.4375 19.5281 27.4375 17.8186 27.4375H10.1814C9.78952 27.4375 9.41505 27.4375 9.05756 27.4358C9.03852 27.4369 9.01933 27.4375 9 27.4375C8.97711 27.4375 8.95442 27.4367 8.93194 27.4351C7.78507 27.428 6.81632 27.4002 6.01031 27.2919C4.88518 27.1406 3.93783 26.817 3.18544 26.0646C2.43304 25.3122 2.10942 24.3648 1.95815 23.2397C1.838 22.346 1.81695 21.2523 1.81327 19.9375H1.5C0.982233 19.9375 0.5625 19.5178 0.5625 19C0.5625 18.4822 0.982233 18.0625 1.5 18.0625H1.8125V14.9375H1.5C0.982233 14.9375 0.5625 14.5178 0.5625 14C0.5625 13.4822 0.982233 13.0625 1.5 13.0625H1.8125V9.9375H1.5C0.982233 9.9375 0.5625 9.51777 0.5625 9C0.5625 8.48223 0.982233 8.0625 1.5 8.0625H1.81327C1.81695 6.74773 1.838 5.65399 1.95815 4.76031C2.10942 3.63518 2.43304 2.68783 3.18544 1.93544C3.93783 1.18304 4.88518 0.859425 6.01031 0.708155C7.09402 0.562454 8.47192 0.562475 10.1814 0.562501ZM3.6875 9.9375H4C4.51777 9.9375 4.9375 9.51777 4.9375 9C4.9375 8.48223 4.51777 8.0625 4 8.0625H3.68847C3.69247 6.75525 3.71287 5.78047 3.81643 5.01015C3.93975 4.09293 4.16531 3.60722 4.51126 3.26126C4.85722 2.91531 5.34293 2.68975 6.26015 2.56644C6.76225 2.49893 7.35122 2.46676 8.0625 2.45143V25.5486C7.35122 25.5332 6.76225 25.5011 6.26015 25.4336C5.34293 25.3103 4.85722 25.0847 4.51126 24.7387C4.16531 24.3928 3.93975 23.9071 3.81643 22.9899C3.71287 22.2195 3.69247 21.2447 3.68847 19.9375H4C4.51777 19.9375 4.9375 19.5178 4.9375 19C4.9375 18.4822 4.51777 18.0625 4 18.0625H3.6875V14.9375H4C4.51777 14.9375 4.9375 14.5178 4.9375 14C4.9375 13.4822 4.51777 13.0625 4 13.0625H3.6875V9.9375ZM9.9375 25.5625C10.0398 25.5625 10.144 25.5625 10.25 25.5625H17.75C19.5443 25.5625 20.7957 25.5605 21.7398 25.4336C22.6571 25.3103 23.1428 25.0847 23.4887 24.7387C23.8347 24.3928 24.0603 23.9071 24.1836 22.9899C24.3105 22.0457 24.3125 20.7943 24.3125 19V9C24.3125 7.20573 24.3105 5.95434 24.1836 5.01015C24.0603 4.09293 23.8347 3.60722 23.4887 3.26126C23.1428 2.91531 22.6571 2.68975 21.7398 2.56644C20.7957 2.43949 19.5443 2.4375 17.75 2.4375H10.25C10.144 2.4375 10.0398 2.43751 9.9375 2.43755V25.5625ZM12.4375 7.125C12.4375 6.60723 12.8572 6.1875 13.375 6.1875H19.625C20.1428 6.1875 20.5625 6.60723 20.5625 7.125C20.5625 7.64277 20.1428 8.0625 19.625 8.0625H13.375C12.8572 8.0625 12.4375 7.64277 12.4375 7.125ZM12.4375 11.5C12.4375 10.9822 12.8572 10.5625 13.375 10.5625H19.625C20.1428 10.5625 20.5625 10.9822 20.5625 11.5C20.5625 12.0178 20.1428 12.4375 19.625 12.4375H13.375C12.8572 12.4375 12.4375 12.0178 12.4375 11.5Z"
                        fill="#2B2B2B"
                      />
                    </svg>
                    <span>Darsliklar</span>
                  </NavLink>
                  <NavLink
                    id="RouterNavLink"
                    to="/settings"
                    className={({ isActive }) =>
                      isActive ? `${navbar.active}` : ""
                    }
                  >
                    <svg
                      className={navbar.color_fill}
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15 9.76744C11.9478 9.76744 9.47351 12.1101 9.47351 15C9.47351 17.8899 11.9478 20.2326 15 20.2326C18.0522 20.2326 20.5265 17.8899 20.5265 15C20.5265 12.1101 18.0522 9.76744 15 9.76744ZM11.6841 15C11.6841 13.2661 13.1687 11.8605 15 11.8605C16.8313 11.8605 18.3159 13.2661 18.3159 15C18.3159 16.7339 16.8313 18.1395 15 18.1395C13.1687 18.1395 11.6841 16.7339 11.6841 15Z"
                        fill="#2B2B2B"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.9628 3.82465e-07C14.3078 -9.84736e-06 13.761 -1.84142e-05 13.312 0.0289819C12.8447 0.059171 12.4033 0.124254 11.9753 0.292091C10.9823 0.681544 10.1933 1.42855 9.78199 2.36877C9.56785 2.85825 9.50986 3.37412 9.48771 3.93483C9.46991 4.38557 9.22965 4.76164 8.87509 4.95546C8.52054 5.14927 8.05643 5.15823 7.63526 4.94746C7.1113 4.68526 6.61046 4.47488 6.05566 4.40572C4.99 4.27289 3.91224 4.54631 3.0595 5.16584C2.692 5.43283 2.41176 5.76224 2.15049 6.13033C1.8995 6.48393 1.6261 6.9323 1.2986 7.46939L1.26138 7.53043C0.933867 8.06751 0.660455 8.51587 0.462523 8.89846C0.256475 9.29674 0.0952941 9.69124 0.0348321 10.1261C-0.105465 11.135 0.183318 12.1555 0.837652 12.9629C1.17826 13.3831 1.62104 13.6886 2.12276 13.9871C2.52624 14.2271 2.75014 14.6122 2.75012 15C2.75009 15.3877 2.52619 15.7727 2.12276 16.0127C1.62098 16.3112 1.17815 16.6167 0.837508 17.037C0.183174 17.8444 -0.10561 18.8649 0.0346878 19.8738C0.0951498 20.3087 0.256331 20.7032 0.462378 21.1014C0.660308 21.484 0.933715 21.9324 1.26123 22.4694L1.29846 22.5305C1.62596 23.0676 1.89936 23.516 2.15034 23.8696C2.41162 24.2377 2.69186 24.5671 3.05935 24.8341C3.9121 25.4536 4.98985 25.727 6.05552 25.5942C6.61028 25.525 7.1111 25.3147 7.63502 25.0525C8.05625 24.8417 8.52042 24.8507 8.87502 25.0445C9.22962 25.2383 9.4699 25.6145 9.48771 26.0652C9.50986 26.6259 9.56786 27.1418 9.78199 27.6312C10.1933 28.5715 10.9823 29.3185 11.9753 29.7079C12.4033 29.8757 12.8447 29.9408 13.312 29.971C13.761 30 14.3078 30 14.9628 30H15.0372C15.6922 30 16.239 30 16.688 29.971C17.1553 29.9408 17.5967 29.8757 18.0247 29.7079C19.0177 29.3185 19.8067 28.5715 20.218 27.6312C20.4322 27.1417 20.4901 26.6259 20.5123 26.0651C20.5301 25.6144 20.7703 25.2383 21.1249 25.0445C21.4795 24.8506 21.9436 24.8416 22.3649 25.0524C22.8888 25.3146 23.3896 25.5249 23.9443 25.5941C25.01 25.7269 26.0878 25.4535 26.9405 24.834C27.308 24.567 27.5882 24.2376 27.8495 23.8695C28.1005 23.5159 28.3739 23.0676 28.7013 22.5305L28.7386 22.4694C29.0661 21.9324 29.3396 21.4839 29.5375 21.1013C29.7435 20.7031 29.9047 20.3086 29.9652 19.8737C30.1055 18.8648 29.8167 17.8443 29.1624 17.0369C28.8217 16.6166 28.3789 16.3112 27.8772 16.0127C27.4737 15.7727 27.2499 15.3876 27.2499 14.9999C27.2499 14.6123 27.4738 14.2273 27.8771 13.9873C28.379 13.6888 28.8218 13.3833 29.1625 12.963C29.8168 12.1556 30.1056 11.1351 29.9653 10.1262C29.9049 9.69133 29.7437 9.29684 29.5376 8.89856C29.3397 8.51599 29.0663 8.06767 28.7388 7.53063L28.7016 7.46955C28.3741 6.93245 28.1006 6.48402 27.8497 6.13042C27.5884 5.76233 27.3081 5.43293 26.9406 5.16594C26.0879 4.5464 25.0101 4.27298 23.9445 4.40582C23.3897 4.47497 22.8889 4.68533 22.365 4.94751C21.9437 5.1583 21.4796 5.14934 21.125 4.9555C20.7704 4.76166 20.5301 4.38554 20.5123 3.93475C20.4901 3.37407 20.4321 2.85823 20.218 2.36877C19.8067 1.42855 19.0177 0.681544 18.0247 0.292091C17.5967 0.124254 17.1553 0.059171 16.688 0.0289819C16.239 -1.84142e-05 15.6922 -9.84736e-06 15.0372 3.82465e-07H14.9628ZM12.8213 2.22579C12.935 2.1812 13.1077 2.14007 13.4625 2.11715C13.8272 2.09359 14.2982 2.09302 15 2.09302C15.7018 2.09302 16.1728 2.09359 16.5375 2.11715C16.8923 2.14007 17.065 2.1812 17.1787 2.22579C17.6301 2.40282 17.9887 2.74236 18.1757 3.16974C18.2347 3.30455 18.2835 3.51471 18.3032 4.01298C18.3469 5.11863 18.9496 6.18319 20.0197 6.76811C21.0897 7.35304 22.3648 7.31498 23.398 6.79797C23.8636 6.56497 24.0802 6.49998 24.233 6.48093C24.7174 6.42055 25.2073 6.54484 25.5949 6.82644C25.6926 6.89738 25.8165 7.01846 26.0149 7.2979C26.2188 7.58515 26.4548 7.97107 26.8057 8.54651C27.1566 9.12196 27.3916 9.50844 27.5524 9.81926C27.7088 10.1216 27.7576 10.2838 27.7736 10.3993C27.8374 10.858 27.7061 11.3218 27.4087 11.6888C27.3149 11.8046 27.1471 11.9498 26.7011 12.2151C25.7117 12.8037 25.0393 13.8301 25.0393 14.9998C25.0392 16.1697 25.7116 17.1963 26.7011 17.7849C27.147 18.0502 27.3147 18.1953 27.4086 18.3111C27.706 18.6781 27.8372 19.1419 27.7735 19.6006C27.7574 19.7161 27.7087 19.8783 27.5522 20.1806C27.3914 20.4915 27.1565 20.8779 26.8056 21.4534C26.4547 22.0288 26.2187 22.4148 26.0148 22.702C25.8164 22.9814 25.6924 23.1025 25.5948 23.1735C25.2072 23.4551 24.7173 23.5793 24.2329 23.519C24.0801 23.4999 23.8634 23.4349 23.3979 23.202C22.3647 22.6849 21.0895 22.6469 20.0195 23.2319C18.9496 23.8168 18.3469 24.8813 18.3032 25.9869C18.2836 26.4853 18.2347 26.6954 18.1757 26.8303C17.9887 27.2576 17.6301 27.5972 17.1787 27.7742C17.065 27.8188 16.8923 27.8599 16.5375 27.8829C16.1728 27.9064 15.7018 27.907 15 27.907C14.2982 27.907 13.8272 27.9064 13.4625 27.8829C13.1077 27.8599 12.935 27.8188 12.8213 27.7742C12.3699 27.5972 12.0113 27.2576 11.8243 26.8303C11.7653 26.6955 11.7165 26.4853 11.6968 25.987C11.6531 24.8814 11.0504 23.8168 9.98032 23.2319C8.91029 22.647 7.63519 22.685 6.60205 23.202C6.13645 23.435 5.91978 23.5 5.76698 23.5191C5.28258 23.5794 4.7927 23.4552 4.40508 23.1736C4.30744 23.1026 4.18345 22.9815 3.9851 22.7021C3.78121 22.4149 3.54519 22.0289 3.19429 21.4535C2.84339 20.878 2.60841 20.4916 2.44762 20.1807C2.29119 19.8784 2.24244 19.7162 2.22638 19.6006C2.16261 19.142 2.29387 18.6782 2.5913 18.3112C2.68512 18.1954 2.8529 18.0503 3.29884 17.785C4.28829 17.1964 4.96065 16.1699 4.96072 15.0001C4.96079 13.8301 4.28839 12.8035 3.29886 12.2149C2.85302 11.9496 2.68525 11.8045 2.59144 11.6887C2.29402 11.3217 2.16275 10.8579 2.22652 10.3993C2.24259 10.2837 2.29134 10.1215 2.44776 9.81916C2.60856 9.50834 2.84354 9.12187 3.19444 8.54642C3.54534 7.97097 3.78135 7.58506 3.98525 7.2978C4.18359 7.01836 4.30759 6.89728 4.40523 6.82635C4.79284 6.54474 5.28273 6.42046 5.76712 6.48084C5.91993 6.49989 6.13661 6.56488 6.60227 6.79791C7.63536 7.31491 8.91041 7.35296 9.98038 6.76807C11.0504 6.18318 11.6531 5.11866 11.6968 4.01305C11.7165 3.51472 11.7653 3.30456 11.8243 3.16974C12.0113 2.74237 12.3699 2.40282 12.8213 2.22579Z"
                        fill="#2B2B2B"
                      />
                    </svg>

                    <span>Sozlamalar</span>
                  </NavLink>
                </>
              ) : (
                <>
                  {who?.includes("4") && (
                    <>
                      <NavLink
                        id="RouterNavLink"
                        to="/reception"
                        className={({ isActive }) =>
                          isActive ? `${navbar.active}` : ""
                        }
                      >
                        <svg
                          className={navbar.color_fill}
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M26.4727 6.83321L15.2227 3.0832C15.0781 3.03496 14.9219 3.03496 14.7773 3.0832L3.52734 6.83321C3.38744 6.87991 3.26577 6.96943 3.17954 7.08909C3.09332 7.20876 3.04691 7.35251 3.04688 7.5V16.875C3.04688 17.0615 3.12095 17.2403 3.25282 17.3722C3.38468 17.504 3.56352 17.5781 3.75 17.5781C3.93648 17.5781 4.11532 17.504 4.24718 17.3722C4.37905 17.2403 4.45312 17.0615 4.45312 16.875V8.475L8.98594 9.98672C8.41433 10.8315 8.02699 11.7871 7.84912 12.7915C7.67125 13.7958 7.70683 14.8263 7.95356 15.816C8.20029 16.8057 8.65264 17.7324 9.28116 18.5357C9.90968 19.339 10.7003 20.001 11.6016 20.4785C9.3457 21.2438 7.38281 22.7742 5.97656 24.9316C5.89573 25.0865 5.87541 25.2658 5.91956 25.4348C5.96371 25.6038 6.06918 25.7503 6.21541 25.8458C6.36165 25.9413 6.53819 25.9789 6.71066 25.9514C6.88314 25.9239 7.03919 25.8331 7.14844 25.6969C8.96133 22.9207 11.8219 21.3281 15 21.3281C18.1781 21.3281 21.0387 22.9207 22.8516 25.6969C22.9601 25.836 23.1171 25.9293 23.2912 25.9581C23.4654 25.9868 23.644 25.9491 23.7916 25.8523C23.9392 25.7554 24.0449 25.6067 24.0879 25.4354C24.1308 25.2642 24.1078 25.0831 24.0234 24.9281C22.6172 22.7742 20.6566 21.2438 18.3984 20.475C19.2992 19.9969 20.0893 19.3346 20.7172 18.531C21.3451 17.7275 21.7969 16.8007 22.043 15.8111C22.2892 14.8215 22.3243 13.7911 22.146 12.787C21.9677 11.7829 21.58 10.8276 21.0082 9.98321L26.4727 8.1668C26.6125 8.12002 26.7341 8.03047 26.8202 7.91081C26.9063 7.79115 26.9527 7.64744 26.9527 7.5C26.9527 7.35256 26.9063 7.20885 26.8202 7.08919C26.7341 6.96953 26.6125 6.87998 26.4727 6.83321ZM20.8594 14.0625C20.8598 14.9962 20.6371 15.9164 20.2098 16.7466C19.7825 17.5767 19.163 18.2928 18.403 18.835C17.6429 19.3773 16.7642 19.73 15.8402 19.8639C14.9162 19.9978 13.9736 19.9089 13.0909 19.6047C12.2081 19.3005 11.4109 18.7897 10.7656 18.115C10.1202 17.4403 9.64547 16.6211 9.38086 15.7257C9.11625 14.8303 9.06945 13.8846 9.24434 12.9675C9.41924 12.0504 9.81078 11.1883 10.3863 10.4531L14.7773 11.9168C14.9219 11.965 15.0781 11.965 15.2227 11.9168L19.6137 10.4531C20.422 11.4824 20.8608 12.7537 20.8594 14.0625ZM15 10.5094L5.97656 7.5L15 4.49063L24.0234 7.5L15 10.5094Z"
                            fill="#2B2B2B"
                          />
                        </svg>
                        <span>Qabulxona</span>
                      </NavLink>
                      <NavLink
                        id="RouterNavLink"
                        to="/groups"
                        className={({ isActive }) =>
                          isActive ? `${navbar.active}` : ""
                        }
                      >
                        <svg
                          className={navbar.color_fill}
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M11.8304 3.52572C13.8588 2.57476 16.1411 2.57476 18.1695 3.52572L26.5335 7.44695C27.8488 8.06363 28.4375 9.40278 28.4375 10.625C28.4375 11.8473 27.8488 13.1864 26.5335 13.8031L24.6875 14.6685V20.7818C24.6875 22.3481 23.9022 23.8603 22.4725 24.6521C21.5329 25.1725 20.298 25.7989 18.9985 26.2975C17.7144 26.7901 16.2924 27.1875 15 27.1875C13.7076 27.1875 12.2856 26.7901 11.0015 26.2975C9.70198 25.7989 8.46713 25.1725 7.52748 24.6521C6.09782 23.8603 5.3125 22.3481 5.3125 20.7818V14.6685L3.46654 13.803L3.4375 13.7893V17.5C3.4375 18.0178 3.01777 18.4375 2.5 18.4375C1.98223 18.4375 1.5625 18.0178 1.5625 17.5V10.625C1.5625 9.40275 2.15118 8.06357 3.46655 7.4469L11.8304 3.52572ZM7.1875 15.5475V20.7818C7.1875 21.7355 7.66094 22.5827 8.43585 23.0118C9.33166 23.5079 10.4835 24.0905 11.6731 24.5469C12.8779 25.0091 14.0474 25.3125 15 25.3125C15.9526 25.3125 17.1221 25.0091 18.3269 24.5469C19.5165 24.0905 20.6683 23.5079 21.5641 23.0118C22.3391 22.5827 22.8125 21.7355 22.8125 20.7818V15.5476L18.1696 17.7243C16.1412 18.6752 13.8589 18.6752 11.8305 17.7243L7.1875 15.5475ZM4.26246 12.1054C3.75848 11.8691 3.4375 11.3055 3.4375 10.625C3.4375 9.94447 3.75849 9.38086 4.26246 9.14459L12.6264 5.22341C14.1505 4.50886 15.8494 4.50886 17.3735 5.22341L25.7375 9.14464C26.2415 9.38091 26.5625 9.94452 26.5625 10.625C26.5625 11.3055 26.2415 11.8691 25.7375 12.1054L17.3736 16.0266C15.8495 16.7411 14.1506 16.7411 12.6265 16.0266L4.26246 12.1054Z"
                            fill="#2B2B2B"
                          />
                        </svg>

                        <span>Sinflar</span>
                      </NavLink>
                    </>
                  )}
                  {
                     who?.includes("3") && (
                      <>
                                      <NavLink
                        id="RouterNavLink"
                        to="/groups"
                        className={({ isActive }) =>
                          isActive ? `${navbar.active}` : ""
                        }
                      >
                        <svg
                          className={navbar.color_fill}
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M11.8304 3.52572C13.8588 2.57476 16.1411 2.57476 18.1695 3.52572L26.5335 7.44695C27.8488 8.06363 28.4375 9.40278 28.4375 10.625C28.4375 11.8473 27.8488 13.1864 26.5335 13.8031L24.6875 14.6685V20.7818C24.6875 22.3481 23.9022 23.8603 22.4725 24.6521C21.5329 25.1725 20.298 25.7989 18.9985 26.2975C17.7144 26.7901 16.2924 27.1875 15 27.1875C13.7076 27.1875 12.2856 26.7901 11.0015 26.2975C9.70198 25.7989 8.46713 25.1725 7.52748 24.6521C6.09782 23.8603 5.3125 22.3481 5.3125 20.7818V14.6685L3.46654 13.803L3.4375 13.7893V17.5C3.4375 18.0178 3.01777 18.4375 2.5 18.4375C1.98223 18.4375 1.5625 18.0178 1.5625 17.5V10.625C1.5625 9.40275 2.15118 8.06357 3.46655 7.4469L11.8304 3.52572ZM7.1875 15.5475V20.7818C7.1875 21.7355 7.66094 22.5827 8.43585 23.0118C9.33166 23.5079 10.4835 24.0905 11.6731 24.5469C12.8779 25.0091 14.0474 25.3125 15 25.3125C15.9526 25.3125 17.1221 25.0091 18.3269 24.5469C19.5165 24.0905 20.6683 23.5079 21.5641 23.0118C22.3391 22.5827 22.8125 21.7355 22.8125 20.7818V15.5476L18.1696 17.7243C16.1412 18.6752 13.8589 18.6752 11.8305 17.7243L7.1875 15.5475ZM4.26246 12.1054C3.75848 11.8691 3.4375 11.3055 3.4375 10.625C3.4375 9.94447 3.75849 9.38086 4.26246 9.14459L12.6264 5.22341C14.1505 4.50886 15.8494 4.50886 17.3735 5.22341L25.7375 9.14464C26.2415 9.38091 26.5625 9.94452 26.5625 10.625C26.5625 11.3055 26.2415 11.8691 25.7375 12.1054L17.3736 16.0266C15.8495 16.7411 14.1506 16.7411 12.6265 16.0266L4.26246 12.1054Z"
                            fill="#2B2B2B"
                          />
                        </svg>
    
                        <span>Sinflar</span>
                      </NavLink>
                      <NavLink
                        id="RouterNavLink"
                        to="/lessons"
                        className={({ isActive }) =>
                          isActive ? `${navbar.active}` : ""
                        }
                      >
                        <svg
                          className={navbar.color_fill}
                          width="27"
                          height="28"
                          viewBox="0 0 27 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10.1814 0.562501H17.8186C19.5281 0.562475 20.906 0.562454 21.9897 0.708155C23.1148 0.859425 24.0622 1.18304 24.8146 1.93544C25.567 2.68783 25.8906 3.63518 26.0418 4.76031C26.1875 5.84402 26.1875 7.22192 26.1875 8.93141V19.0686C26.1875 20.7781 26.1875 22.156 26.0418 23.2397C25.8906 24.3648 25.567 25.3122 24.8146 26.0646C24.0622 26.817 23.1148 27.1406 21.9897 27.2919C20.906 27.4375 19.5281 27.4375 17.8186 27.4375H10.1814C9.78952 27.4375 9.41505 27.4375 9.05756 27.4358C9.03852 27.4369 9.01933 27.4375 9 27.4375C8.97711 27.4375 8.95442 27.4367 8.93194 27.4351C7.78507 27.428 6.81632 27.4002 6.01031 27.2919C4.88518 27.1406 3.93783 26.817 3.18544 26.0646C2.43304 25.3122 2.10942 24.3648 1.95815 23.2397C1.838 22.346 1.81695 21.2523 1.81327 19.9375H1.5C0.982233 19.9375 0.5625 19.5178 0.5625 19C0.5625 18.4822 0.982233 18.0625 1.5 18.0625H1.8125V14.9375H1.5C0.982233 14.9375 0.5625 14.5178 0.5625 14C0.5625 13.4822 0.982233 13.0625 1.5 13.0625H1.8125V9.9375H1.5C0.982233 9.9375 0.5625 9.51777 0.5625 9C0.5625 8.48223 0.982233 8.0625 1.5 8.0625H1.81327C1.81695 6.74773 1.838 5.65399 1.95815 4.76031C2.10942 3.63518 2.43304 2.68783 3.18544 1.93544C3.93783 1.18304 4.88518 0.859425 6.01031 0.708155C7.09402 0.562454 8.47192 0.562475 10.1814 0.562501ZM3.6875 9.9375H4C4.51777 9.9375 4.9375 9.51777 4.9375 9C4.9375 8.48223 4.51777 8.0625 4 8.0625H3.68847C3.69247 6.75525 3.71287 5.78047 3.81643 5.01015C3.93975 4.09293 4.16531 3.60722 4.51126 3.26126C4.85722 2.91531 5.34293 2.68975 6.26015 2.56644C6.76225 2.49893 7.35122 2.46676 8.0625 2.45143V25.5486C7.35122 25.5332 6.76225 25.5011 6.26015 25.4336C5.34293 25.3103 4.85722 25.0847 4.51126 24.7387C4.16531 24.3928 3.93975 23.9071 3.81643 22.9899C3.71287 22.2195 3.69247 21.2447 3.68847 19.9375H4C4.51777 19.9375 4.9375 19.5178 4.9375 19C4.9375 18.4822 4.51777 18.0625 4 18.0625H3.6875V14.9375H4C4.51777 14.9375 4.9375 14.5178 4.9375 14C4.9375 13.4822 4.51777 13.0625 4 13.0625H3.6875V9.9375ZM9.9375 25.5625C10.0398 25.5625 10.144 25.5625 10.25 25.5625H17.75C19.5443 25.5625 20.7957 25.5605 21.7398 25.4336C22.6571 25.3103 23.1428 25.0847 23.4887 24.7387C23.8347 24.3928 24.0603 23.9071 24.1836 22.9899C24.3105 22.0457 24.3125 20.7943 24.3125 19V9C24.3125 7.20573 24.3105 5.95434 24.1836 5.01015C24.0603 4.09293 23.8347 3.60722 23.4887 3.26126C23.1428 2.91531 22.6571 2.68975 21.7398 2.56644C20.7957 2.43949 19.5443 2.4375 17.75 2.4375H10.25C10.144 2.4375 10.0398 2.43751 9.9375 2.43755V25.5625ZM12.4375 7.125C12.4375 6.60723 12.8572 6.1875 13.375 6.1875H19.625C20.1428 6.1875 20.5625 6.60723 20.5625 7.125C20.5625 7.64277 20.1428 8.0625 19.625 8.0625H13.375C12.8572 8.0625 12.4375 7.64277 12.4375 7.125ZM12.4375 11.5C12.4375 10.9822 12.8572 10.5625 13.375 10.5625H19.625C20.1428 10.5625 20.5625 10.9822 20.5625 11.5C20.5625 12.0178 20.1428 12.4375 19.625 12.4375H13.375C12.8572 12.4375 12.4375 12.0178 12.4375 11.5Z"
                            fill="#2B2B2B"
                          />
                        </svg>
                        <span>Darsliklar</span>
                      </NavLink>
                      </>
                    )
                  }
                  {
                     who?.includes("2") && (
                      <>
                          <NavLink
                        id="RouterNavLink"
                        to="/teacher"
                        className={({ isActive }) =>
                          isActive ? `${navbar.active}` : ""
                        }
                      >
                        <svg
                          className={navbar.color_fill}
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M15 15C17.7625 15 20 12.7625 20 10C20 7.2375 17.7625 5 15 5C12.2375 5 10 7.2375 10 10C10 12.7625 12.2375 15 15 15ZM21.25 10C21.25 13.4531 18.4531 16.25 15 16.25C11.5469 16.25 8.75 13.4531 8.75 10C8.75 6.54688 11.5469 3.75 15 3.75C18.4531 3.75 21.25 6.54688 21.25 10ZM5.76437 21.3825C5.1375 21.8888 5 22.2681 5 22.5V25H25V22.5C25 22.2687 24.8625 21.8881 24.235 21.3825C23.6225 20.8881 22.7087 20.4169 21.6012 20.0094C19.3875 19.195 16.7206 18.75 15 18.75C13.2794 18.75 10.6125 19.195 8.39875 20.0094C7.29125 20.4169 6.3775 20.8881 5.76437 21.3825ZM15 17.5C11.245 17.5 3.75 19.3969 3.75 22.5V26.25H26.25V22.5C26.25 19.3969 18.755 17.5 15 17.5Z"
                            fill="#2B2B2B"
                          />
                        </svg>

                        <span>O'qituvchilar</span>
                      </NavLink>
                        <NavLink
                        id="RouterNavLink"
                        to="/budget"
                        className={({ isActive }) =>
                          isActive ? `${navbar.active}` : ""
                        }
                      >
                        <svg
                          className={navbar.color_storke}
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="15"
                            cy="15"
                            r="12.5"
                            stroke="#2B2B2B"
                            strokeWidth="1.5"
                          />
                          <path
                            d="M15 21.25V21.875V22.5"
                            stroke="#2B2B2B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                          />
                          <path
                            d="M15 7.5V8.125V8.75"
                            stroke="#2B2B2B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                          />
                          <path
                            d="M18.75 11.875C18.75 10.1491 17.0711 8.75 15 8.75C12.9289 8.75 11.25 10.1491 11.25 11.875C11.25 13.6009 12.9289 15 15 15C17.0711 15 18.75 16.3991 18.75 18.125C18.75 19.8509 17.0711 21.25 15 21.25C12.9289 21.25 11.25 19.8509 11.25 18.125"
                            stroke="#2B2B2B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                          />
                        </svg>

                        <span>Budjet</span>
                      </NavLink>
                      <NavLink
                        id="RouterNavLink"
                        to="/get-payment"
                        className={({ isActive }) =>
                          isActive ? `${navbar.active}` : ""
                        }
                      >
                        <i className="fa-solidt fa-money-check-dollar-pen text-2xl "></i>
                        <span>To'lov olish</span>
                      </NavLink>
                      </>
                    )
                  }
                  {
                    who?.includes("5") && (
                      <>
                      <NavLink
                        id="RouterNavLink"
                        to="/reception"
                        className={({ isActive }) =>
                          isActive ? `${navbar.active}` : ""
                        }
                      >
                        <svg
                          className={navbar.color_fill}
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M26.4727 6.83321L15.2227 3.0832C15.0781 3.03496 14.9219 3.03496 14.7773 3.0832L3.52734 6.83321C3.38744 6.87991 3.26577 6.96943 3.17954 7.08909C3.09332 7.20876 3.04691 7.35251 3.04688 7.5V16.875C3.04688 17.0615 3.12095 17.2403 3.25282 17.3722C3.38468 17.504 3.56352 17.5781 3.75 17.5781C3.93648 17.5781 4.11532 17.504 4.24718 17.3722C4.37905 17.2403 4.45312 17.0615 4.45312 16.875V8.475L8.98594 9.98672C8.41433 10.8315 8.02699 11.7871 7.84912 12.7915C7.67125 13.7958 7.70683 14.8263 7.95356 15.816C8.20029 16.8057 8.65264 17.7324 9.28116 18.5357C9.90968 19.339 10.7003 20.001 11.6016 20.4785C9.3457 21.2438 7.38281 22.7742 5.97656 24.9316C5.89573 25.0865 5.87541 25.2658 5.91956 25.4348C5.96371 25.6038 6.06918 25.7503 6.21541 25.8458C6.36165 25.9413 6.53819 25.9789 6.71066 25.9514C6.88314 25.9239 7.03919 25.8331 7.14844 25.6969C8.96133 22.9207 11.8219 21.3281 15 21.3281C18.1781 21.3281 21.0387 22.9207 22.8516 25.6969C22.9601 25.836 23.1171 25.9293 23.2912 25.9581C23.4654 25.9868 23.644 25.9491 23.7916 25.8523C23.9392 25.7554 24.0449 25.6067 24.0879 25.4354C24.1308 25.2642 24.1078 25.0831 24.0234 24.9281C22.6172 22.7742 20.6566 21.2438 18.3984 20.475C19.2992 19.9969 20.0893 19.3346 20.7172 18.531C21.3451 17.7275 21.7969 16.8007 22.043 15.8111C22.2892 14.8215 22.3243 13.7911 22.146 12.787C21.9677 11.7829 21.58 10.8276 21.0082 9.98321L26.4727 8.1668C26.6125 8.12002 26.7341 8.03047 26.8202 7.91081C26.9063 7.79115 26.9527 7.64744 26.9527 7.5C26.9527 7.35256 26.9063 7.20885 26.8202 7.08919C26.7341 6.96953 26.6125 6.87998 26.4727 6.83321ZM20.8594 14.0625C20.8598 14.9962 20.6371 15.9164 20.2098 16.7466C19.7825 17.5767 19.163 18.2928 18.403 18.835C17.6429 19.3773 16.7642 19.73 15.8402 19.8639C14.9162 19.9978 13.9736 19.9089 13.0909 19.6047C12.2081 19.3005 11.4109 18.7897 10.7656 18.115C10.1202 17.4403 9.64547 16.6211 9.38086 15.7257C9.11625 14.8303 9.06945 13.8846 9.24434 12.9675C9.41924 12.0504 9.81078 11.1883 10.3863 10.4531L14.7773 11.9168C14.9219 11.965 15.0781 11.965 15.2227 11.9168L19.6137 10.4531C20.422 11.4824 20.8608 12.7537 20.8594 14.0625ZM15 10.5094L5.97656 7.5L15 4.49063L24.0234 7.5L15 10.5094Z"
                            fill="#2B2B2B"
                          />
                        </svg>
                        <span>Qabulxona</span>
                      </NavLink>
                      <NavLink
                        id="RouterNavLink"
                        to="/groups"
                        className={({ isActive }) =>
                          isActive ? `${navbar.active}` : ""
                        }
                      >
                        <svg
                          className={navbar.color_fill}
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M11.8304 3.52572C13.8588 2.57476 16.1411 2.57476 18.1695 3.52572L26.5335 7.44695C27.8488 8.06363 28.4375 9.40278 28.4375 10.625C28.4375 11.8473 27.8488 13.1864 26.5335 13.8031L24.6875 14.6685V20.7818C24.6875 22.3481 23.9022 23.8603 22.4725 24.6521C21.5329 25.1725 20.298 25.7989 18.9985 26.2975C17.7144 26.7901 16.2924 27.1875 15 27.1875C13.7076 27.1875 12.2856 26.7901 11.0015 26.2975C9.70198 25.7989 8.46713 25.1725 7.52748 24.6521C6.09782 23.8603 5.3125 22.3481 5.3125 20.7818V14.6685L3.46654 13.803L3.4375 13.7893V17.5C3.4375 18.0178 3.01777 18.4375 2.5 18.4375C1.98223 18.4375 1.5625 18.0178 1.5625 17.5V10.625C1.5625 9.40275 2.15118 8.06357 3.46655 7.4469L11.8304 3.52572ZM7.1875 15.5475V20.7818C7.1875 21.7355 7.66094 22.5827 8.43585 23.0118C9.33166 23.5079 10.4835 24.0905 11.6731 24.5469C12.8779 25.0091 14.0474 25.3125 15 25.3125C15.9526 25.3125 17.1221 25.0091 18.3269 24.5469C19.5165 24.0905 20.6683 23.5079 21.5641 23.0118C22.3391 22.5827 22.8125 21.7355 22.8125 20.7818V15.5476L18.1696 17.7243C16.1412 18.6752 13.8589 18.6752 11.8305 17.7243L7.1875 15.5475ZM4.26246 12.1054C3.75848 11.8691 3.4375 11.3055 3.4375 10.625C3.4375 9.94447 3.75849 9.38086 4.26246 9.14459L12.6264 5.22341C14.1505 4.50886 15.8494 4.50886 17.3735 5.22341L25.7375 9.14464C26.2415 9.38091 26.5625 9.94452 26.5625 10.625C26.5625 11.3055 26.2415 11.8691 25.7375 12.1054L17.3736 16.0266C15.8495 16.7411 14.1506 16.7411 12.6265 16.0266L4.26246 12.1054Z"
                            fill="#2B2B2B"
                          />
                        </svg>

                        <span>Sinflar</span>
                      </NavLink>
                      <NavLink
                        id="RouterNavLink"
                        to="/settings/payments/"
                        className={({ isActive }) =>
                          isActive ? `${navbar.active}` : ""
                        }
                      >
                        <i className="fa-solid text-2xl fa-money-bill-wave"></i>
                        <span>To'lovlar</span>
                      </NavLink>
                      <NavLink
                        id="RouterNavLink"
                        to="/settings/allcomments/"
                        className={({ isActive }) =>
                          isActive ? `${navbar.active}` : ""
                        }
                      >
                        <i className="fa-solid text-2xl fa-comments"></i>
                        <span>Fikrlar</span>
                      </NavLink>
                      </>
                    )
                  }
                </>
              )
              }

              <NavLink
                id="RouterNavLink"
                to="/logout"
                className={({ isActive }) =>
                  isActive ? `${navbar.active} ${navbar.logout}` : navbar.logout
                }
              >
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.6817 1.5625C16.9722 1.56248 15.5943 1.56246 14.5106 1.70816C13.3854 1.85943 12.4381 2.18304 11.6857 2.93544C11.0295 3.5916 10.698 4.39794 10.524 5.34544C10.3548 6.26614 10.3225 7.39287 10.315 8.74478C10.3121 9.26254 10.7295 9.6846 11.2472 9.68749C11.765 9.69037 12.187 9.27298 12.1899 8.75522C12.1975 7.38835 12.233 6.41949 12.3681 5.68418C12.4982 4.97567 12.7072 4.56558 13.0115 4.26126C13.3575 3.91531 13.8432 3.68975 14.7604 3.56644C15.7046 3.43949 16.956 3.4375 18.7503 3.4375H20.0003C21.7945 3.4375 23.0459 3.43949 23.9901 3.56644C24.9073 3.68975 25.3931 3.91531 25.739 4.26126C26.085 4.60722 26.3105 5.09293 26.4338 6.01015C26.5608 6.95434 26.5628 8.20573 26.5628 10V20C26.5628 21.7943 26.5608 23.0457 26.4338 23.9899C26.3105 24.9071 26.085 25.3928 25.739 25.7387C25.3931 26.0847 24.9073 26.3103 23.9901 26.4336C23.0459 26.5605 21.7945 26.5625 20.0003 26.5625H18.7503C16.956 26.5625 15.7046 26.5605 14.7604 26.4336C13.8432 26.3103 13.3575 26.0847 13.0115 25.7387C12.7072 25.4344 12.4982 25.0243 12.3681 24.3158C12.233 23.5805 12.1975 22.6117 12.1899 21.2448C12.187 20.727 11.765 20.3096 11.2472 20.3125C10.7295 20.3154 10.3121 20.7375 10.315 21.2552C10.3225 22.6071 10.3548 23.7339 10.524 24.6546C10.698 25.6021 11.0295 26.4084 11.6857 27.0646C12.4381 27.817 13.3854 28.1406 14.5106 28.2919C15.5943 28.4375 16.9722 28.4375 18.6817 28.4375H20.0689C21.7783 28.4375 23.1562 28.4375 24.24 28.2919C25.3651 28.1406 26.3124 27.817 27.0648 27.0646C27.8172 26.3122 28.1408 25.3648 28.2921 24.2397C28.4378 23.156 28.4378 21.7781 28.4378 20.0686V9.93142C28.4378 8.22193 28.4378 6.84402 28.2921 5.76031C28.1408 4.63518 27.8172 3.68783 27.0648 2.93544C26.3124 2.18304 25.3651 1.85943 24.24 1.70816C23.1563 1.56246 21.7784 1.56248 20.0689 1.5625H18.6817Z"
                    fill="#D23F3F"
                  />
                  <path
                    d="M2.50122 14.0613C1.98345 14.0613 1.56372 14.481 1.56372 14.9988C1.56372 15.5165 1.98345 15.9363 2.50122 15.9363L17.4669 15.9363L15.0161 18.037C14.623 18.3739 14.5775 18.9658 14.9144 19.3589C15.2514 19.752 15.8432 19.7975 16.2363 19.4606L20.6113 15.7106C20.8191 15.5325 20.9387 15.2725 20.9387 14.9988C20.9387 14.7251 20.8191 14.4651 20.6113 14.287L16.2363 10.537C15.8432 10.2 15.2514 10.2455 14.9144 10.6387C14.5775 11.0318 14.623 11.6236 15.0161 11.9606L17.4669 14.0613L2.50122 14.0613Z"
                    fill="#D23F3F"
                  />
                </svg>
                <span>Chiqish</span>
              </NavLink>
            </div>
          </div>

          <NavLink id="RouterNavLink" to="/" className={navbar.premium}>
            <center>
              <span style={{ marginLeft: "-5px" }}>Premiumga</span>
              <div className={navbar.second_content}>
                <span>Yangilang</span>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 10.7502C11.4983 10.7502 11.1857 11.075 11.0135 11.2998C10.8492 11.5144 10.6837 11.8114 10.5141 12.1159L10.3926 12.3339C10.3698 12.3748 10.3518 12.4069 10.3361 12.4345C10.3088 12.4409 10.277 12.4481 10.2373 12.4571L9.99947 12.5109C9.67166 12.5849 9.34588 12.6586 9.09579 12.7571C8.81965 12.8659 8.44535 13.0779 8.30109 13.5418C8.15937 13.9975 8.3382 14.3835 8.49439 14.6316C8.63894 14.8612 8.85863 15.118 9.08354 15.3809L9.24421 15.5688C9.27869 15.6091 9.30468 15.6395 9.32658 15.6658C9.32359 15.7022 9.31951 15.7445 9.31402 15.8011L9.28984 16.0506C9.25567 16.4025 9.22264 16.7426 9.23476 17.0146C9.24746 17.2999 9.31592 17.7317 9.70309 18.0256C10.1025 18.3288 10.5436 18.2627 10.8233 18.1826C11.0811 18.1087 11.3856 17.9684 11.6923 17.8271L11.9151 17.7245C11.9486 17.7091 11.9761 17.6964 12 17.6856C12.0115 17.6908 12.0237 17.6964 12.0371 17.7025C12.0516 17.7091 12.0675 17.7164 12.0849 17.7245L12.3077 17.8271C12.6144 17.9684 12.919 18.1087 13.1767 18.1826C13.4565 18.2627 13.8976 18.3288 14.297 18.0256C14.6841 17.7317 14.7526 17.2999 14.7653 17.0146C14.7774 16.7426 14.7444 16.4025 14.7102 16.0505L14.686 15.8011C14.6806 15.7445 14.6765 15.7022 14.6735 15.6658C14.6954 15.6395 14.7214 15.6091 14.7559 15.5688L14.9165 15.3809C15.1414 15.118 15.3611 14.8612 15.5057 14.6316C15.6619 14.3835 15.8407 13.9975 15.699 13.5418C15.5547 13.0779 15.1804 12.8659 14.9043 12.7571C14.6542 12.6586 14.3284 12.5849 14.0006 12.5109L13.7628 12.4571C13.723 12.4481 13.6913 12.4409 13.6639 12.4345C13.6482 12.4069 13.6303 12.3748 13.6075 12.3338L13.486 12.1159C13.3163 11.8114 13.1509 11.5144 12.9865 11.2998C12.8144 11.075 12.5017 10.7502 12 10.7502ZM11.8011 12.8878C11.8773 12.7512 11.9419 12.6353 12 12.5346C12.0582 12.6353 12.1228 12.7512 12.199 12.8878L12.2973 13.0642L12.3196 13.1048C12.3982 13.2484 12.5282 13.4863 12.7451 13.6509C12.9664 13.8189 13.2327 13.8767 13.3884 13.9106L13.4318 13.9201L13.6227 13.9633C13.7978 14.0029 13.9405 14.0352 14.0625 14.0659C13.9832 14.1636 13.8801 14.2849 13.746 14.4417L13.6159 14.5939L13.5859 14.6286C13.478 14.7529 13.3037 14.9536 13.2231 15.2128C13.1435 15.4688 13.1709 15.7326 13.1883 15.899L13.193 15.9458L13.2127 16.1488C13.231 16.3371 13.2451 16.4873 13.2546 16.6095C13.1504 16.5636 13.0318 16.5091 12.891 16.4443L12.7123 16.362L12.6719 16.3431C12.5284 16.2754 12.2787 16.1576 12 16.1576C11.7214 16.1576 11.4717 16.2754 11.3282 16.3431L11.2878 16.362L11.1091 16.4443C10.9682 16.5091 10.8497 16.5636 10.7455 16.6095C10.7549 16.4873 10.7691 16.3371 10.7874 16.1488L10.807 15.9458L10.8118 15.899C10.8291 15.7326 10.8566 15.4688 10.777 15.2128C10.6964 14.9536 10.5221 14.7529 10.4142 14.6286L10.3842 14.5939L10.2541 14.4417C10.12 14.2849 10.0169 14.1636 9.93753 14.0659C10.0595 14.0352 10.2022 14.0029 10.3774 13.9633L10.5683 13.9201L10.6116 13.9106C10.7673 13.8767 11.0336 13.8189 11.255 13.6509C11.4718 13.4863 11.6019 13.2484 11.6804 13.1048L11.7028 13.0642L11.8011 12.8878ZM10.7394 17.0117C10.7393 17.0117 10.7391 17.0107 10.7387 17.0085L10.7394 17.0117ZM13.2607 17.0117L13.2614 17.0085C13.261 17.0107 13.2607 17.0117 13.2607 17.0117Z"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 1.25C11.2937 1.25 10.8451 1.74936 10.5434 2.19718C10.2372 2.65167 9.91768 3.30649 9.53886 4.08283L7.27608 8.71959C7.05705 9.16843 6.91614 9.45523 6.79388 9.65422C6.70903 9.79233 6.66267 9.83677 6.65181 9.8462C6.62056 9.86072 6.59142 9.86537 6.56457 9.86347C6.54723 9.85385 6.49864 9.82316 6.40929 9.74055C6.24721 9.59068 6.04541 9.36242 5.72538 8.9981L5.69628 8.96497C5.1236 8.313 4.65579 7.78042 4.27048 7.42022C4.07291 7.23552 3.86525 7.0653 3.64699 6.9433C3.42506 6.81924 3.14638 6.71955 2.8284 6.74748C2.35533 6.78903 1.93556 7.02828 1.64125 7.38387C1.28618 7.81286 1.24622 8.41259 1.25026 8.93104C1.25461 9.4911 1.32458 10.2344 1.41151 11.158L1.64885 13.6798C1.83384 15.6455 1.97873 17.185 2.22971 18.381C2.4854 19.5995 2.86979 20.5636 3.60382 21.3145C4.34888 22.0767 5.26436 22.4254 6.39573 22.5909C7.48403 22.75 8.85869 22.75 10.5806 22.75H13.4194C15.1414 22.75 16.516 22.75 17.6043 22.5909C18.7357 22.4254 19.6512 22.0767 20.3963 21.3145C21.1303 20.5636 21.5147 19.5995 21.7704 18.381C22.0213 17.185 22.1662 15.6455 22.3512 13.6798L22.5886 11.158C22.6755 10.2344 22.7455 9.49109 22.7498 8.93104C22.7538 8.41259 22.7139 7.81286 22.3588 7.38387C22.0645 7.02828 21.6447 6.78903 21.1717 6.74748C20.8537 6.71955 20.575 6.81924 20.3531 6.9433C20.1348 7.0653 19.9272 7.23552 19.7296 7.42022C19.3443 7.78043 18.8765 8.313 18.3038 8.96498L18.2747 8.9981C17.9547 9.36242 17.7529 9.59068 17.5908 9.74055C17.5014 9.82316 17.4528 9.85385 17.4355 9.86347C17.4086 9.86537 17.3795 9.86072 17.3483 9.8462C17.3374 9.83677 17.291 9.79232 17.2062 9.65422C17.0839 9.45523 16.943 9.16842 16.724 8.71958L14.4612 4.08282C14.0824 3.30648 13.7629 2.65167 13.4567 2.19717C13.155 1.74935 12.7064 1.25 12 1.25ZM10.861 4.79379C11.2727 3.95013 11.547 3.39205 11.7874 3.03525C11.8892 2.88414 11.9592 2.80859 12 2.7722C12.0409 2.80859 12.1109 2.88414 12.2127 3.03525C12.453 3.39205 12.7274 3.95013 13.1391 4.79378L15.3917 9.40969C15.5904 9.81688 15.763 10.1707 15.9281 10.4395C16.0972 10.7147 16.3203 11.0082 16.6676 11.183C16.9811 11.3408 17.3342 11.3987 17.6837 11.3435C18.077 11.2813 18.3755 11.0579 18.6091 10.8419C18.8356 10.6325 19.0892 10.3438 19.3768 10.0164L19.4016 9.98804C20.0105 9.29494 20.4294 8.81934 20.7539 8.51599C20.9145 8.36587 21.0201 8.28889 21.085 8.25262L21.0859 8.25213C21.1196 8.26445 21.1588 8.28885 21.1975 8.33351C21.1975 8.33348 21.1976 8.33349 21.1975 8.33351C21.1972 8.33368 21.1977 8.33563 21.199 8.33985C21.2084 8.36967 21.253 8.51152 21.2499 8.91937C21.2461 9.40668 21.1829 10.0849 21.0915 11.056L20.8623 13.4913C20.6718 15.5153 20.5338 16.9699 20.3023 18.0729C20.0735 19.1632 19.7722 19.8071 19.3236 20.266C18.8861 20.7136 18.324 20.9697 17.3873 21.1067C16.42 21.2481 15.1551 21.25 13.36 21.25H10.6401C8.84501 21.25 7.5801 21.2481 6.61279 21.1067C5.67605 20.9697 5.114 20.7136 4.67644 20.266C4.22785 19.8071 3.92652 19.1632 3.69773 18.0729C3.46628 16.9699 3.32823 15.5153 3.13774 13.4913L2.90854 11.056C2.81715 10.0849 2.754 9.40668 2.75021 8.91937C2.74704 8.5116 2.79153 8.36975 2.80089 8.3399C2.80222 8.33567 2.80284 8.33368 2.80252 8.33352C2.84123 8.28885 2.88044 8.26445 2.91421 8.25213L2.9151 8.25262C2.97998 8.28889 3.08554 8.36587 3.24613 8.51599C3.57063 8.81934 3.9896 9.29494 4.59843 9.98804L4.62331 10.0164C4.91089 10.3438 5.16444 10.6325 5.39095 10.8419C5.62461 11.0579 5.92305 11.2813 6.31634 11.3435C6.66586 11.3987 7.01901 11.3408 7.33245 11.183C7.67982 11.0082 7.90282 10.7147 8.07192 10.4395C8.23706 10.1707 8.40969 9.81692 8.60836 9.40976L10.861 4.79379ZM21.1975 8.33351C21.1994 8.33572 21.2014 8.33797 21.2033 8.34028C21.2009 8.33738 21.1993 8.3353 21.1983 8.33425C21.198 8.33385 21.1977 8.3336 21.1975 8.33351ZM12.0441 2.74096C12.0441 2.74143 12.0409 2.74333 12.0348 2.74527C12.0411 2.74146 12.0441 2.74049 12.0441 2.74096ZM11.9652 2.74527C11.9591 2.74333 11.956 2.74143 11.956 2.74096C11.9559 2.74049 11.959 2.74146 11.9652 2.74527Z"
                    fill="white"
                  />
                </svg>
              </div>
            </center>
            <div className={navbar.content}>Boshlash</div>
          </NavLink>
        </aside>

        <main>
          <Outlet></Outlet>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </main>
      </div>
      {isColorD && (
        <>
          <div
            className={navbar.other_things}
            style={isColorD ? mountedStyle : unmountedStyle}
          >
            <div className={navbar.change_color_modal}>
              {colors?.map((item) => (
                <Colorize
                  item={item}
                  key={item.id}
                  HandleColor={ChangeColor}
                  oncolor={colorTheme}
                />
              ))}
            </div>
          </div>
        </>
      )}
      {/* {isTranslaterD && (
        <>
          <div
            className={navbar.other_things}
            style={isTranslaterD ? mountedStyle : unmountedStyle}
          >
            <div className={navbar.change_color_modal}>
              {language.map((item) => (
                <TranslaterD item={item} key={item.id} />
              ))}
            </div>
          </div>
        </>
      )} */}
      {isNotification && (
        <>
          <div
            className={`${navbar.notification} p-5 `}
            style={isNotification ? mountedStyle : unmountedStyle}
          >
            <div className="flex justify-between items-center">
              <h1 className="text-2xl text-[var(--theme)]">
                <i className="fa-solid fa-bell mx-2"></i>Bildirishnomalar
              </h1>
              <NavLink to="/messages" className="underline hover:no-underline">
                Hammasini o'qish
              </NavLink>
            </div>
            <br />
            <div className="text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:text-gray-400 dark:border-gray-700">
              <ul className="flex flex-wrap -mb-px">
                <li className="mr-2">
                  <a
                    href="#"
                    className="inline-block p-4 border-b-2  border-[var(--theme)] text-[var(--theme)] rounded-t-lg hover:text-gray-600 hover:border-gray-300 "
                  >
                    Hammasi
                  </a>
                </li>
                <li className="mr-2">
                  <a
                    href="#"
                    className="inline-block p-4 border-b-2 border-transparent rounded-t-lg  hover:border-[var(--theme)] hover:text-[var(--theme)]"
                    aria-current="page"
                  >
                    Chatdan
                  </a>
                </li>
                <li className="mr-2">
                  <a
                    href="#"
                    className="inline-block p-4 border-b-2 border-transparent rounded-t-lg hover:border-[var(--theme)] hover:text-[var(--theme)]"
                  >
                    Guruhlar
                  </a>
                </li>
                <li className="mr-2">
                  <a
                    href="#"
                    className="inline-block p-4 border-b-2 border-transparent rounded-t-lg hover:border-[var(--theme)] hover:text-[var(--theme)]"
                  >
                    Dastur tomonidan
                  </a>
                </li>
              </ul>
            </div>
            <br />
            <div className="flow-root">
              <ul
                role="list"
                className="divide-y divide-gray-200 dark:divide-gray-700"
              >
                <li className="py-3 sm:py-4 hover:bg-[var(--theme-bg)] px-3 hover:rounded-xl">
                  <div className="flex items-center space-x-4">
                    <div className="flex-shrink-0">
                      <img
                        className="w-11 h-11 p-1 rounded-full ring-2 ring-[var(--theme)]"
                        src={user_logo}
                        alt="Bordered avatar"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium truncate">Kompaniya</p>
                      <p className="text-sm text-gray-500 truncate dark:text-gray-400">
                        bugun bog'lanish kere
                      </p>
                    </div>
                    <div className="inline-flex items-center text-base font-bold text-[var(--theme)]">
                      +4
                    </div>
                  </div>
                </li>
                <li className="py-3 sm:py-4 hover:bg-[var(--theme-bg)] px-3 hover:rounded-xl">
                  <div className="flex items-center space-x-4">
                    <div className="flex-shrink-0">
                      <img
                        className="w-11 h-11 p-1 rounded-full ring-2 ring-[var(--theme)]"
                        src={user_logo}
                        alt="Bordered avatar"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium truncate">Neil Sims</p>
                      <p className="text-sm text-gray-500 truncate dark:text-gray-400">
                        Salom qalesiz tuzimisiz
                      </p>
                    </div>
                    <div className="inline-flex items-center text-base font-bold text-[var(--theme)]">
                      +4
                    </div>
                  </div>
                </li>
                <li className="py-3 sm:py-4 hover:bg-[var(--theme-bg)] px-3 hover:rounded-xl">
                  <div className="flex items-center space-x-4">
                    <div className="flex-shrink-0">
                      <img
                        className="w-11 h-11 p-1 rounded-full ring-2 ring-[var(--theme)]"
                        src={user_logo}
                        alt="Bordered avatar"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium truncate">Neil Sims</p>
                      <p className="text-sm text-gray-500 truncate dark:text-gray-400">
                        Salom qalesiz tuzimisiz
                      </p>
                    </div>
                    <div className="inline-flex items-center text-base font-bold text-[var(--theme)]">
                      +4
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Root;
